import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  makeStyles,
  Box,
  CircularProgress,
  Snackbar,
  Grid,
  Divider,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardContent,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  useMediaQuery,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Drawer,
  AppBar,
  Toolbar,
  Avatar,
  Chip,
  Popper,
  Radio,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import MessageIcon from "@material-ui/icons/Message";
import BusinessIcon from "@material-ui/icons/Business";
import PersonIcon from "@material-ui/icons/Person";
import PaymentIcon from "@material-ui/icons/Payment";
import SpeedIcon from "@material-ui/icons/Speed";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import AiSensyLogo from "../../static/AiSensyLogo.svg";
// import AiSensyLogo from "../../static/AiSensy_logo_holiday.png";
import partnerLogo8Views from "../../static/logo.81a5e81a.svg";
import { CHECKOUT_PREFIX, INTEGRATION_SERVER_URL } from "../../config/config";
import axios from "axios";
import posthog from "../../config/posthog";
import { getVisitorId } from "../../services/visitorId";
import { currentUtmParams } from "../../services/visitUtm";
import { persistUtmParams } from "../../utils/utmStorage";
import { saveSignupPrefill } from "../../utils/signupPrefill";
import { pushEvent } from "../../utils/dataLayer";
import { useParams, useLocation } from "react-router-dom";
import { countries as countryData } from "../PaymentPages/countryData";
import SearchIcon from "@material-ui/icons/Search";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import CheckIcon from "@material-ui/icons/Check";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import EventNoteIcon from "@material-ui/icons/EventNote";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AlarmOnIcon from "@material-ui/icons/AlarmOn";
import LockIcon from "@material-ui/icons/Lock";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import EventIcon from "@material-ui/icons/Event";
import { ArrowRight, BriefcaseIcon, MessageSquareIcon } from "lucide-react";
import { ShoppingCartOutlined } from "@material-ui/icons";
import WarningIcon from "@material-ui/icons/Warning";
import InfoIcon from "@material-ui/icons/Info";
import { isShopifyPlansSlug } from "./shopifyPlansPixel";

// Custom SVG icon components
const WhatsAppIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M7.253 18.494l.724.423A7.953 7.953 0 0 0 12 20a8 8 0 1 0-8-8c0 1.436.377 2.813 1.084 4.024l.422.724-.653 2.401 2.4-.655zM2.004 22l1.352-4.968A9.954 9.954 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.004 22zM8.391 7.308c.134-.01.269-.01.403-.004.054.004.108.01.162.016.159.018.334.115.393.249.298.676.588 1.357.868 2.04.062.152.025.347-.093.537a4.38 4.38 0 0 1-.263.372c-.113.145-.356.411-.356.411s-.099.118-.061.265c.014.056.06.137.102.205l.059.095c.256.427.6.86 1.02 1.268.12.116.237.235.363.346.468.413.998.75 1.57 1l.005.002c.085.037.128.057.252.11.062.026.126.049.191.066a.35.35 0 0 0 .367-.13c.724-.877.79-.934.796-.934v.002a.482.482 0 0 1 .378-.127c.06.004.121.015.177.04.531.243 1.4.622 1.4.622l.582.261c.098.047.187.158.19.265.004.067.01.175-.013.373-.032.259-.11.565-.217.793-.124.27-.353.45-.646.478-.156.014-.289.017-.424.012-.142-.007-.326-.06-.453-.074-.08-.008-.158-.018-.232-.036-.458-.115-.911-.395-1.24-.644-.55-.41-.856-.685-1.29-1.137-.882-.93-1.49-1.802-1.884-2.779-.1-.248-.176-.497-.255-.747-.034-.107-.064-.214-.094-.32-.064-.227-.125-.455-.18-.682-.115-.466-.36-.958-.134-1.529.097-.231.263-.364.466-.412z"></path>
  </svg>
);

const AIIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2Z"></path>
    <path d="M12 12v6"></path>
    <path d="M8 9h8"></path>
    <path d="M7 4l10 8-10 8"></path>
  </svg>
);

// Keep these as default fallbacks in case API fails
const defaultOrganizationSizes = [
  "1-10 employees",
  "10-20 employees",
  "20-50 employees",
  "50-200 employees",
  "200+ employees",
];

// Default industry options as fallback
const defaultIndustries = [
  "Real Estate",
  "Technology",
  "Finance",
  "Healthcare",
  "Education",
  "E-commerce",
  "Manufacturing",
  "Professional Services",
  "Marketing",
  "Media",
  "Telecommunications",
  "Travel",
  "Government & Public Sector",
  "Non-Profit",
  "Others",
];

// Default plan structure as fallback if API fails
const defaultPlanOptions = {
  monthly: {
    label: "Monthly",
    basic: {
      price: 299,
      originalPrice: 399,
      billed: "per month",
      saving: "",
    },
    pro: {
      price: 699,
      originalPrice: 899,
      billed: "per month",
      saving: "",
    },
  },
  quarterly: {
    label: "Quarterly",
    basic: {
      price: 799,
      originalPrice: 1199,
      billed: "every 3 months",
      saving: "Save 11%",
    },
    pro: {
      price: 1899,
      originalPrice: 2699,
      billed: "every 3 months",
      saving: "Save 10%",
    },
  },
  yearly: {
    label: "Yearly",
    basic: {
      price: 2999,
      originalPrice: 4799,
      billed: "per year",
      saving: "Save 16%",
    },
    pro: {
      price: 6999,
      originalPrice: 10799,
      billed: "per year",
      saving: "Save 17%",
    },
  },
};

// Default plan features as fallback
const defaultPlanFeatures = {
  basic: [
    "1,000 monthly conversations",
    "WhatsApp Business API access",
    "Basic chatbot automation",
    "1 WhatsApp number",
    "Standard support (email)",
    "Basic analytics dashboard",
    "Message templates (10 included)",
  ],
  pro: [
    "5,000 monthly conversations",
    "WhatsApp Business API access",
    "Advanced chatbot with AI capabilities",
    "Multiple WhatsApp numbers",
    "Priority support (email & chat)",
    "Advanced analytics & reporting",
    "Message templates (30 included)",
    "CRM integration",
    "Custom branding",
    "Team collaboration tools",
  ],
};

// Default addons as fallback
const defaultAddons = [
  {
    id: "account-manager",
    title: "Dedicated Account Manager",
    description: "Get a dedicated account manager for premium support",
    price: 299,
    selected: false,
  },
  {
    id: "24-7-support",
    title: "24/7 Premium Support",
    description: "Access round-the-clock technical support",
    price: 199,
    selected: false,
  },
  {
    id: "meta-ads",
    title: "500 AED Meta Ads Credit",
    description: "Start promoting your WhatsApp business with Meta ads",
    price: 400,
    selected: false,
  },
];

const RegionalPlansPage = (props = {}) => {
  const classes = useStyles();
  const theme = useTheme();
  // Allow callers (e.g. AdsCheckoutPage) to override the URL-derived
  // region/version with explicit props. Falls back to useParams() for the
  // legacy /:region-plans-:version route.
  const params = useParams();
  const region = props.region ?? params.region;
  const version = props.version ?? params.version;
  const isAdsRegion = region === "ads";
  // The /ads/:adSlug route lives outside the legacy /:region-plans-:version
  // pattern, so cancelPath needs to be region-aware. Source stays unified
  // ("aisensy_regional_plans") — region discrimination already happens via
  // customer.region downstream.
  const cancelPath = isAdsRegion
    ? `/ads/${version}`
    : `/${region}-plans-${version}`;
  const planSlug = `${region}-plans-${version}`;
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeStep, setActiveStep] = useState(0);
  // dataLayer events fire at most once per visit; Track which have already fired.
  const firedEventsRef = useRef(new Set());
  const fireOnce = (event, data) => {
    if (firedEventsRef.current.has(event)) return;
    firedEventsRef.current.add(event);
    pushEvent(event, data);
  };
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [showError, setShowError] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [cart, setCart] = useState([]);
  const [summaryExpanded, setSummaryExpanded] = useState(false);
  const [expandedFeatures, setExpandedFeatures] = useState({});

  // State for page configuration - will be loaded from API
  const [pageConfig, setPageConfig] = useState({
    region: "",
    currency: "",
    currencySymbol: "",
    title: "",
    subtitle: "",
    organizationSizes: defaultOrganizationSizes,
    industries: defaultIndustries,
    planOptions: defaultPlanOptions,
    planFeatures: defaultPlanFeatures,
    addons: defaultAddons,
    defaultCountry: "AE",
    countryCallingCode: "+971",
    isoCode: "AE",
    gstPercentage: 0,
    gstLabel: "",
  });

  // Config-driven lead-form tweaks (e.g. Shopify page: "Brand Name" label,
  // hidden Industry / Organisation Size). Empty object = default form.
  const leadFormConfig = pageConfig.leadFormConfig || {};

  // UAE mobiles only (5XXXXXXXX or 05XXXXXXXX), with a fixed +971 prefix
  // in place of the country picker.
  const aeMobileOnly = leadFormConfig.phoneRule === "ae_mobile";
  const aePhonePrefix = (
    <InputAdornment position="start" style={{ marginRight: 0 }}>
      <Box className={classes.countryCodeInput} style={{ padding: "0 8px" }}>
        <span style={{ marginRight: 4, fontSize: 16 }}>🇦🇪</span>
        <span style={{ fontSize: 14, fontWeight: 500, color: "#333" }}>
          +971
        </span>
      </Box>
    </InputAdornment>
  );

  // Bundle-offer presentation (saving label chip, no per-item prices, single
  // bundle line in the order summary). Older offer pages are matched by slug;
  // newer ones opt in via the bundleOfferStyle config flag.
  const isBundleOffer =
    version?.includes("end-of-year-offer") || !!pageConfig.bundleOfferStyle;

  // Derived state from pageConfig
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [billingPeriod, setBillingPeriod] = useState("monthly");
  const [plans, setPlans] = useState([]);
  const [addons, setAddons] = useState([]);

  // Form data state
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    organizationName: "",
    organizationSize: "",
    industry: "",
  });

  // Validation errors state
  const [validationErrors, setValidationErrors] = useState({
    fullName: "",
    email: "",
    phone: "",
    organizationName: "",
    organizationSize: "",
    industry: "",
  });

  // Country selection states
  const [countrySearch, setCountrySearch] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(
    countryData.find((country) => country.code === "AE") || countryData[0],
  );

  // Coupon states
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [validatingCoupon, setValidatingCoupon] = useState(false);
  const [couponMessage, setCouponMessage] = useState("");
  const [couponData, setCouponData] = useState(null);

  // Add state to track which addon tooltip is open on mobile
  const [openTooltipId, setOpenTooltipId] = useState(null);

  const [utmParams, setUtmParams] = useState({});

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);

    const utmParameterNames = [
      // Standard UTM parameters
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "utm_id",
      // Google Ads specific parameters
      "campaign_id",
      "adgroup_id",
      "ad_id",
      "creative",
      "keyword",
      "device",
      "matchtype",
      "network",
      "placement",
      "gclid",
      "gad_source",
      "gad_campaignid",
      // Meta Ads and other tracking parameters
      "fbclid",
      "msclkid",
      "ttclid",
      "twclid",
      "li_fat_id",
      "sub_source",
      "source_medium",
      "campaign_id",
      "landing_page_url",
      "referrer_url",
      "first_touch_source",
      "latest_touch_source",
      "ad_created_at",
    ];

    const capturedParams = {};

    utmParameterNames.forEach((param) => {
      const value = urlParams.get(param);
      if (value) {
        capturedParams[param] = value;
      }
    });

    setUtmParams(capturedParams);

    persistUtmParams(capturedParams);

    if (Object.keys(capturedParams).length > 0) {
      console.log("Captured UTM parameters:", capturedParams);
    }
  }, [location.search]);

  // Fetch page configuration from API based on region and version
  useEffect(() => {
    // Track page load
    posthog.capture("plans_page_loaded", {
      region: region,
      version: version,
      billing_period: billingPeriod,
      timestamp: new Date().toISOString(),
      utm_params: utmParams,
    });

    const fetchPageConfig = async () => {
      setLoading(true);
      setApiError(false);

      try {
        const { data } = await axios.get(
          `${INTEGRATION_SERVER_URL}/regionalplans/t1/config/${region}/${version}`,
          // Page-visit analytics rides on this existing request rather than
          // firing a second one. The utm params come from the page url — the
          // server cannot see the address bar — so they are forwarded here or
          // the visit is recorded with no campaign attached.
          {
            headers: { "x-visitor-id": getVisitorId() },
            params: currentUtmParams(),
          },
        );

        if (data.success) {
          // Set the page configuration
          setPageConfig(data.data);

          // Hidden industry field: submit the configured default instead.
          if (data.data.leadFormConfig?.hideIndustry) {
            setFormData((prev) => ({
              ...prev,
              industry: data.data.leadFormConfig.defaultIndustry || "",
            }));
          }

          // Set currency symbol
          setCurrencySymbol(data.data.currencySymbol || "");

          // Get plans directly from API instead of hardcoding basic and pro
          if (Array.isArray(data.data.plans) && data.data.plans.length > 0) {
            // Decide default billing period based on availability (prefer monthly, else first available)
            const availablePeriods = Object.keys(data.data.planOptions || {});
            const defaultPeriod = availablePeriods.includes("monthly")
              ? "monthly"
              : availablePeriods[0] || "quarterly";
            setBillingPeriod(defaultPeriod);
            // Initialize plans with correct structure and respect fixed billing period if provided
            const initialPlans = data.data.plans.map((plan) => {
              const effectivePeriod = plan.fixedBillingPeriod || defaultPeriod;
              const planPricing =
                (data.data.planOptions[effectivePeriod] || {})[plan.id] || {};
              return {
                ...plan,
                price: planPricing.price,
                originalPrice: planPricing.originalPrice,
                billed: planPricing.billed,
                saving: planPricing.saving,
                items: planPricing.items || [],
                usdEquivalent: planPricing.usdEquivalent || null,
                selected: false,
              };
            });
            setPlans(initialPlans);

            // Auto-select the first plan by default
            if (initialPlans.length > 0) {
              const firstPlan = initialPlans[0];
              // Add the first plan to cart automatically
              setCart([
                {
                  ...firstPlan,
                  quantity: 1,
                },
              ]);
            }
          } else {
            // If no plans returned or invalid format, use fallback plans
            throw new Error("No valid plans data received from the API");
          }

          // Initialize addons from configuration
          if (Array.isArray(data.data.addons)) {
            setAddons(
              data.data.addons.map((addon) => ({
                ...addon,
                selected: false,
              })),
            );
          } else {
            setAddons(defaultAddons);
          }

          // Set default country if specified
          if (data.data.defaultCountry) {
            const country = countryData.find(
              (country) => country.code === data.data.defaultCountry,
            );
            if (country) {
              setSelectedCountry(country);
            }
          }
        } else {
          throw new Error(data.message || "Failed to load page configuration");
        }
      } catch (err) {
        console.error("Error fetching page configuration:", err);
        setApiError(true);
        setError("Failed to load page configuration. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchPageConfig();
  }, [region, version]);

  useEffect(() => {
    if (!loading && pageConfig.planOptions && plans.length > 0) {
      setPlans(
        plans.map((plan) => {
          const effectivePeriod = plan.fixedBillingPeriod || billingPeriod;
          if (
            pageConfig.planOptions[effectivePeriod] &&
            pageConfig.planOptions[effectivePeriod][plan.id]
          ) {
            return {
              ...plan,
              price: pageConfig.planOptions[effectivePeriod][plan.id].price,
              originalPrice:
                pageConfig.planOptions[effectivePeriod][plan.id].originalPrice,
              billed: pageConfig.planOptions[effectivePeriod][plan.id].billed,
              saving: pageConfig.planOptions[effectivePeriod][plan.id].saving,
              items:
                pageConfig.planOptions[effectivePeriod][plan.id].items || [],
              usdEquivalent:
                pageConfig.planOptions[effectivePeriod][plan.id]
                  ?.usdEquivalent || null,
            };
          }
          return plan;
        }),
      );
    }
  }, [billingPeriod, loading, pageConfig.planOptions]);

  // Auto-select the only plan when user moves to the plans step
  useEffect(() => {
    if (activeStep === 1 && plans.length === 1 && cart.length === 0) {
      // Add the only plan to cart automatically
      setCart([
        {
          ...plans[0],
          quantity: 1,
        },
      ]);
    }
  }, [activeStep, plans, cart.length]);

  useEffect(() => {
    if (!loading && !apiError) {
      fireOnce("as_form_view", { region, version });
    }
  }, [loading, apiError]);

  useEffect(() => {
    if (activeStep === 1) {
      fireOnce("as_plans_view", { region, version });
    }
  }, [activeStep]);

  useEffect(() => {
    // Add meta tag to prevent zooming when input is focused on mobile devices
    const metaTag = document.createElement("meta");
    metaTag.name = "viewport";
    metaTag.content =
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
    document.getElementsByTagName("head")[0].appendChild(metaTag);

    return () => {
      document.getElementsByTagName("head")[0].removeChild(metaTag);
    };
  }, []);




  useEffect(() => {
    document.title = "AiSensy Checkout";

    const titleObserver = new MutationObserver(() => {
      if (document.title !== "AiSensy Checkout") {
        document.title = "AiSensy Checkout";
      }
    });

    titleObserver.observe(document.querySelector("title"), {
      childList: true,
      characterData: true,
      subtree: true,
    });

    return () => {
      titleObserver.disconnect();
    };
  }, []);


  // Add Clarity analytics script
  useEffect(() => {
    const clarityScriptId = "clarity-script";
    if (document.getElementById(clarityScriptId)) {
      return;
    }

    const clarityScript = document.createElement("script");
    clarityScript.id = clarityScriptId;
    clarityScript.type = "text/javascript";
    clarityScript.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "v6d5f4kx6j");
    `;
    document.head.appendChild(clarityScript);

    return () => {
      const existingClarityScript = document.getElementById(clarityScriptId);
      if (existingClarityScript) {
        document.head.removeChild(existingClarityScript);
      }
    };
  }, []);

  // Load Razorpay script
  useEffect(() => {
    const scriptId = "razorpay-checkout-script";
    if (document.getElementById(scriptId)) {
      return;
    }

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  // Loading indicator
  if (loading) {
    return (
      <div className={classes.root}>
        <Container className={classes.container} maxWidth="md">
          <Box className={classes.headerLogo}>
            <img
              src={AiSensyLogo}
              alt="AiSensy Logo"
              className={classes.logo}
            />
          </Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="60vh"
          >
            <CircularProgress
              size={60}
              thickness={4}
              style={{ color: "#04cf66" }}
            />
          </Box>
        </Container>
      </div>
    );
  }

  // Show error message if API fails
  if (apiError) {
    return (
      <div className={classes.root}>
        <Container className={classes.container} maxWidth="md">
          <Box className={classes.headerLogo}>
            <img
              src={AiSensyLogo}
              alt="AiSensy Logo"
              className={classes.logo}
            />
          </Box>
          <Paper elevation={0} className={classes.formContainer}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              p={4}
            >
              <Typography variant="h5" gutterBottom>
                Something Went Wrong
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                We're having a little trouble loading your plans—no worries,
                this is usually resolved quickly!
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Please{" "}
                <a
                  href="https://aisensy.com/contact-us"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#04cf66",
                    fontWeight: 600,
                    textDecoration: "none",
                  }}
                >
                  contact our support team
                </a>{" "}
                and we'll help you get started.
              </Typography>
            </Box>
          </Paper>
        </Container>
      </div>
    );
  }

  // Country selection handlers
  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
  };

  // Filter countries based on search
  const filteredCountries = countryData.filter(
    (country) =>
      country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
      country.dial_code.includes(countrySearch),
  );

  // Form handlers
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setValidationErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    // Identify user when email is entered
    if (name === "email" && value && value.includes("@")) {
      posthog.identify(value, {
        email: value,
        region: region,
      });
    }
  };

  // Validation functions
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]+$/;
    return phoneRegex.test(phone.replace(/\D/g, ""));
  };

  // Form validation
  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!formData.fullName.trim()) {
      errors.fullName = "Full name is required";
      isValid = false;
    }

    if (!formData.email) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!validateEmail(formData.email)) {
      errors.email = "Please enter a valid email address";
      isValid = false;
    }

    if (!formData.phone) {
      errors.phone = "Phone number is required";
      isValid = false;
    } else if (aeMobileOnly && !/^0?5\d{8}$/.test(formData.phone)) {
      errors.phone = formData.phone.startsWith("05")
        ? "Numbers starting with 05 must be 10 digits, e.g. 0501234567"
        : formData.phone.startsWith("5")
          ? "Numbers starting with 5 must be 9 digits, e.g. 501234567"
          : "UAE mobile numbers start with 5 or 05";
      isValid = false;
    } else if (!validatePhone(formData.phone)) {
      errors.phone = "Please enter a valid phone number";
      isValid = false;
    }

    if (!formData.organizationName.trim()) {
      errors.organizationName = `${
        leadFormConfig.organizationNameLabel || "Organization name"
      } is required`;
      isValid = false;
    }

    if (!leadFormConfig.hideOrganizationSize && !formData.organizationSize) {
      errors.organizationSize = "Organization size is required";
      isValid = false;
    }

    if (!leadFormConfig.hideIndustry && !formData.industry) {
      errors.industry = "Industry is required";
      isValid = false;
    }

    setValidationErrors(errors);
    return isValid;
  };

  // Update this method to calculate the subtotal from cart items and selected addons
  const getSubtotal = () => {
    let subtotal = 0;

    // Add up plan prices from cart (bundle price, already discounted)
    cart.forEach((item) => {
      subtotal += Number(item.price || 0);
    });

    // Add selected addons if any
    addons.forEach((addon) => {
      if (addon.selected) {
        subtotal += Number(addon.price || 0);
      }
    });

    return subtotal;
  };

  // Calculate GST amount
  const getGstAmount = () => {
    if (!pageConfig.gstPercentage || pageConfig.gstPercentage <= 0) {
      return 0;
    }
    const subtotalAfterDiscount = getSubtotal() - discount;
    const gst = parseFloat(
      (subtotalAfterDiscount * (pageConfig.gstPercentage / 100)).toFixed(3),
    );
    return gst;
  };

  // Update this method to apply any discounts from coupon and add GST
  const getTotalAmount = () => {
    const subtotal = getSubtotal();
    let amountAfterDiscount = subtotal;

    // Apply discount if coupon is applied
    if (couponApplied && couponData) {
      amountAfterDiscount = parseFloat((subtotal - discount).toFixed(3));
    }

    const gstAmount = getGstAmount();
    const finalTotal = parseFloat((amountAfterDiscount + gstAmount).toFixed(3));

    return finalTotal;
  };

  const getTotalUsdEquivalent = () => {
    let totalUsd = 0;

    // Add up plan USD equivalents from cart
    cart.forEach((item) => {
      const effectivePeriod = item.fixedBillingPeriod || billingPeriod;
      if (
        item.id &&
        pageConfig.planOptions[effectivePeriod] &&
        pageConfig.planOptions[effectivePeriod][item.id]
      ) {
        const planUsdEquivalent =
          pageConfig.planOptions[effectivePeriod][item.id]?.usdEquivalent || 0;
        totalUsd += planUsdEquivalent;
      }
    });

    // Add selected addons USD equivalents, IF addons can have usdEquivalent
    // Assuming addons might have their own usdEquivalent property directly
    addons.forEach((addon) => {
      if (addon.selected && addon.usdEquivalent) {
        // Check if addon has usdEquivalent property
        totalUsd += addon.usdEquivalent;
      }
    });

    return parseFloat(totalUsd.toFixed(2)); // Return as a number with 2 decimal places
  };

  // Add this helper function to check if the cart has items
  const hasItems = () => {
    return cart.length > 0 || addons.some((addon) => addon.selected);
  };

  // Update handleProceed to use the cart data
  const handleProceed = async () => {
    if (activeStep === 0) {
      // First step - validate user details
      const isValid = validateForm();
      if (!isValid) {
        return;
      }

      setFormSubmitting(true);

      try {
        // Make API call and wait for response
        const response = await axios.post(
          `${INTEGRATION_SERVER_URL}/regionalplans/t1/submit-form`,
          {
            fullName: formData.fullName,
            email: formData.email,
            phone: formData.phone,
            organizationName: formData.organizationName,
            organizationSize: formData.organizationSize,
            industry: formData.industry,
            region: region,
            version: version,
            source: "aisensy_regional_plans",
            isoCode: selectedCountry.code,
            countryCallingCode: selectedCountry.dial_code,
            utmParams: utmParams,
            // Same id sent on the page-view, so a lead can be traced back to
            // the visit that produced it.
            visitorId: getVisitorId(),
          },
        );

        // Only proceed if API call was successful
        if (response.data && response.data.success) {
          // the thank-you page pre-fills its signup form from these
          saveSignupPrefill({
            fullName: formData.fullName,
            email: formData.email,
            phone: formData.phone,
            countryCode: selectedCountry.dial_code,
            company: formData.organizationName,
          });
          // Track step progression
          posthog.capture("plans_step_proceeded", {
            from_step: "user_details",
            to_step: "plans",
            region: region,
            user_email: formData.email,
          });
          fireOnce("as_signup_success", { region, version });

          // Move to the next step
          setActiveStep(1);
          try {
            const url = new URL(window.location.href);
            url.searchParams.set("view", "plans");
            window.history.replaceState(
              {},
              "",
              `${url.pathname}?${url.searchParams.toString()}`,
            );
          } catch (error) {}

          // Scroll to top when changing to step 2
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          // Handle unsuccessful response
          throw new Error(
            response.data?.message ||
              "Form submission failed. Please try again.",
          );
        }
      } catch (err) {
        if (err?.response?.data?.errors?.length > 0) {
          const firstError = err.response.data.errors[0];

          // Format the error message based on the path
          if (firstError.path) {
            setError(
              `Invalid ${
                firstError.path.charAt(0).toUpperCase() +
                firstError.path.slice(1)
              }.`,
            );
          } else {
            setError(
              err.response.data.message ||
                "There was an error processing your request. Please try again.",
            );
          }
        } else {
          setError(
            err.message ||
              "There was an error processing your request. Please try again.",
          );
        }

        setShowError(true);
      } finally {
        setFormSubmitting(false);
      }
    } else {
      // Second step - process plan selection and complete checkout
      if (!hasItems()) {
        setError("Please select at least one plan to continue.");
        setShowError(true);
        return;
      }

      // Call handleSubmit to handle the checkout process
      handleSubmit();
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Add billing period change handler
  const handleBillingPeriodChange = (event, newBillingPeriod) => {
    if (newBillingPeriod !== null) {
      // Track billing period change
      posthog.capture("billing_period_changed", {
        from_period: billingPeriod,
        to_period: newBillingPeriod,
        region: region,
      });

      setBillingPeriod(newBillingPeriod);

      // Update cart with new pricing based on billing period
      if (cart.length > 0) {
        const updatedCart = cart.map((item) => {
          const effectivePeriod = item.fixedBillingPeriod || newBillingPeriod;
          const planPrice =
            pageConfig.planOptions[effectivePeriod][item.id]?.price ||
            item.price;
          const planItems =
            pageConfig.planOptions[effectivePeriod][item.id]?.items ||
            item.items ||
            [];
          return {
            ...item,
            price: planPrice,
            originalPrice:
              pageConfig.planOptions[effectivePeriod][item.id]?.originalPrice ||
              planPrice,
            items: planItems,
          };
        });
        setCart(updatedCart);

        // Reset coupon when billing period changes
        setCouponApplied(false);
        setCouponCode("");
        setCouponMessage("");
        setCouponData(null);
        setDiscount(0);
      }
      // If there's only one plan and cart is empty, auto-select it with new billing period pricing
      else if (plans.length === 1) {
        const singlePlan = plans[0];
        const effectivePeriod =
          singlePlan.fixedBillingPeriod || newBillingPeriod;
        const planPrice =
          pageConfig.planOptions[effectivePeriod][singlePlan.id]?.price ||
          singlePlan.price;
        const originalPrice =
          pageConfig.planOptions[effectivePeriod][singlePlan.id]
            ?.originalPrice || planPrice;

        setCart([
          {
            ...singlePlan,
            price: planPrice,
            originalPrice: originalPrice,
            quantity: 1,
          },
        ]);
      }
    }
  };

  // Coupon handlers
  const handleCouponChange = (e) => {
    const upperCaseValue = e.target.value.toUpperCase();
    setCouponCode(upperCaseValue);
    if (couponApplied) {
      setCouponApplied(false);
      setDiscount(0);
      setCouponMessage("");
      setCouponData(null);
    }
  };

  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponMessage("Please enter a coupon code");
      return;
    }

    setValidatingCoupon(true);
    setCouponMessage("");

    try {
      const response = await axios.post(
        `${INTEGRATION_SERVER_URL}/coupons/t1/verify`,
        {
          couponCode,
          amount: getSubtotal(),
          applyTo: `${region}-${version}`, // uae-1
        },
      );

      if (response.data.success) {
        setCouponApplied(true);
        const couponInfo = response.data.data;
        setCouponData(couponInfo);

        let discountAmount = 0;
        const subtotal = getSubtotal();

        if (couponInfo.discountType === "percentage") {
          // Calculate percentage discount with 3 decimal places
          discountAmount = parseFloat(
            ((subtotal * couponInfo.discountValue) / 100).toFixed(3),
          );
        } else if (couponInfo.discountType === "fixed") {
          // Apply fixed discount with 3 decimal places
          discountAmount = parseFloat(couponInfo.discountValue.toFixed(3));
        }

        // Ensure discount doesn't exceed subtotal
        discountAmount = parseFloat(
          Math.min(discountAmount, subtotal).toFixed(3),
        );

        setDiscount(discountAmount);
        setCouponMessage("Coupon verified successfully!");
      } else {
        setCouponApplied(false);
        setDiscount(0);
        setCouponData(null);
        setCouponMessage(response.data.message || "Invalid coupon code");
      }
    } catch (err) {
      console.error("Coupon verification error:", err);
      setCouponApplied(false);
      setDiscount(0);
      setCouponData(null);
      setCouponMessage(
        err.response?.data?.message || "Failed to verify coupon",
      );
    } finally {
      setValidatingCoupon(false);
    }
  };

  // Step content for the stepper
  const steps = [
    {
      label: "Your Details",
      icon: <AccountBoxIcon />,
    },
    {
      label: "Select Plan",
      icon: <EmojiEventsIcon />,
    },
  ];

  // Custom step icon component
  const CustomStepIcon = ({ active, completed, icon }) => {
    if (completed) {
      return (
        <div className={classes.customStepIcon}>
          <CheckIcon style={{ fontSize: "14px" }} />
        </div>
      );
    }
    if (active) {
      return <div className={classes.customStepIcon}>{icon}</div>;
    }
    return (
      <div className={`${classes.customStepIcon} ${classes.inactiveStepIcon}`}>
        {icon}
      </div>
    );
  };

  // Render user details step
  const renderUserDetailsStep = () => (
    <Container className={classes.container} maxWidth="lg">
      {/* Desktop layout - 50/50 split */}
      {!isMobile && (
        <Grid container spacing={3}>
          {/* Left half - Logo, heading and features */}
          <Grid item xs={12} md={5}>
            <Box
              className={classes.headerLogo}
              style={{ marginBottom: "16px" }}
            >
              <img
                src={AiSensyLogo}
                alt="AiSensy Logo"
                className={classes.logo}
              />
              {pageConfig.isCobranded &&
                pageConfig.partnerName === "8Views" && (
                  <>
                    <span className={classes.partnerSeparator}>×</span>
                    <img
                      src={partnerLogo8Views}
                      alt="8Views Logo"
                      className={classes.partnerLogo}
                      style={{ height: "45px" }}
                    />
                  </>
                )}
              {pageConfig.isCobranded &&
                pageConfig.partnerLogo &&
                pageConfig.partnerName !== "8Views" && (
                  <>
                    <span className={classes.partnerSeparator}>×</span>
                    <img
                      src={pageConfig.partnerLogo}
                      alt={`${pageConfig.partnerName} Logo`}
                      className={classes.partnerLogo}
                    />
                  </>
                )}
            </Box>
            {pageConfig.isCobranded && (
              <Box className={classes.partnershipBadge}>
                <Typography variant="caption" className={classes.badgeText}>
                  In Partnership with {pageConfig.partnerName}
                </Typography>
              </Box>
            )}

            {/* Main headline with green accent */}
            <Typography
              variant="h4"
              style={{
                fontSize: "28px",
                fontWeight: 700,
                marginBottom: "12px",
                fontFamily:
                  "'Inter', 'Helvetica', 'Arial', sans-serif",
                width: "90%",
              }}
            >
              {isAdsRegion ? (
                pageConfig.title
              ) : pageConfig.heroTitle ? (
                pageConfig.heroTitle
              ) : (
                <>
                  Your First Step to{" "}
                  <span style={{ color: "#04cf66" }}>5x</span> Business
                  Engagement with AI
                </>
              )}
            </Typography>

            {/* Feature badges in a row */}
            {/* <Box
              className={classes.featureBadges}
              style={{ marginBottom: "18px" }}
            >
              <Chip
                icon={<WhatsAppIcon className={classes.customIcon} />}
                label="WhatsApp"
                className={classes.whatsappChip}
                size="medium"
              />
              <Chip
                icon={<AIIcon className={classes.customIcon} />}
                label="AI-Powered"
                className={classes.aiChip}
                size="medium"
              />
              <Chip
                icon={<BriefcaseIcon className={classes.customIcon} />}
                label="Business"
                className={classes.businessChip}
                size="medium"
              />
            </Box> */}

            {/* Benefits section */}
            <Box>
              <Typography
                variant="h6"
                gutterBottom
                className={classes.sideContentTitle}
                style={{ marginBottom: "4px" }}
              >
                {isAdsRegion
                  ? pageConfig.subtitle
                  : pageConfig.sidebarTitle ||
                    "Why Choose AiSensy for WhatsApp Business?"}
              </Typography>

              {/* Benefits */}
              {(pageConfig.benefits?.length > 0
                ? pageConfig.benefits
                : [
                    {
                      title: "Official WhatsApp Business API Partner",
                      description:
                        "Get verified WhatsApp Business account with green tick",
                    },
                    {
                      title: "Powerful AI Chatbots",
                      description:
                        "Create no-code WhatsApp chatbots to automate customer support",
                    },
                    {
                      title: "Broadcasts & Campaigns",
                      description:
                        "Send personalized messages to thousands of customers instantly",
                    },
                    {
                      title: "Seamless CRM Integration",
                      description:
                        "Connect with your existing tools and workflows",
                    },
                  ]
              ).map((benefit, index) => (
                <Box key={index} className={classes.benefitItem}>
                  <CheckCircleIcon className={classes.benefitIcon} />
                  <Box>
                    <Typography
                      variant="subtitle2"
                      className={classes.benefitTitle}
                    >
                      {benefit.title}
                    </Typography>
                    <Typography variant="body2" className={classes.benefitDesc}>
                      {benefit.description}
                    </Typography>
                  </Box>
                </Box>
              ))}

              {/* Testimonial */}
              {/* <Box
                className={classes.testimonial}
                style={{ marginTop: "18px", width: "80%" }}
              >
                <Typography variant="body2" className={classes.testimonialText}>
                  "
                  {pageConfig.testimonial?.quote ||
                    "AiSensy has transformed how we connect with customers. The results speak for themselves - 40% increase in response rates!"}
                  "
                </Typography>
                <Box className={classes.testimonialAuthor}>
                  <Avatar
                    src={
                      pageConfig.testimonial?.avatar ||
                      "https://randomuser.me/api/portraits/men/36.jpg"
                    }
                    className={classes.testimonialAvatar}
                  />
                  <Box>
                    <Typography variant="subtitle2">
                      {pageConfig.testimonial?.name || "Ahmed Hassan"}
                    </Typography>
                    <Typography variant="caption">
                      {pageConfig.testimonial?.position ||
                        "Marketing Director, TeknoPros"}
                    </Typography>
                  </Box>
                </Box>
              </Box> */}
            </Box>
          </Grid>

          {/* Right half - form */}
          <Grid item xs={12} md={7}>
            <Typography
              variant="h5"
              style={{
                marginBottom: "8px",
                fontSize: "24px",
                fontWeight: 600,
                width: "100%",
              }}
            >
              Tell Us About Your Business
            </Typography>

            <Box>
              <Typography variant="body2" className={classes.formFieldLabel}>
                Name*
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                required
                placeholder="Enter your full name"
                name="fullName"
                value={formData.fullName}
                onChange={(e) => {
                  const value = e.target.value;
                  const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
                  handleChange({
                    target: {
                      name: "fullName",
                      value: sanitizedValue,
                    },
                  });
                }}
                className={classes.formField}
                error={!!validationErrors.fullName}
                helperText={validationErrors.fullName}
                InputLabelProps={{ shrink: false }}
              />

              <Typography variant="body2" className={classes.formFieldLabel}>
                Email Address*
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                required
                type="email"
                placeholder="Enter your email address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={classes.formField}
                error={!!validationErrors.email}
                helperText={validationErrors.email}
                InputLabelProps={{ shrink: false }}
              />

              <Box position="relative">
                <Typography variant="body2" className={classes.formFieldLabel}>
                  Phone Number*
                </Typography>
                <Box className={classes.phoneInputContainer}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    required
                    placeholder="Enter your phone number"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(
                        /[^0-9]/g,
                        "",
                      );
                      handleChange({
                        target: {
                          name: "phone",
                          value: numericValue,
                        },
                      });
                    }}
                    className={classes.formField}
                    error={!!validationErrors.phone}
                    helperText={validationErrors.phone}
                    InputLabelProps={{ shrink: false }}
                    type="tel"
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      ...(aeMobileOnly ? { maxLength: 10 } : {}),
                    }}
                    InputProps={{
                      startAdornment: aeMobileOnly ? aePhonePrefix : (
                        <InputAdornment
                          position="start"
                          style={{ marginRight: 0 }}
                        >
                          <Box className={classes.countryCodeInput}>
                            <Select
                              id="countrySelect"
                              value={selectedCountry.code}
                              onChange={(e) => {
                                const country = countryData.find(
                                  (c) => c.code === e.target.value,
                                );
                                if (country) {
                                  setSelectedCountry(country);
                                  const phoneWithoutCode =
                                    formData.phone.replace(/^\+\d+/, "");
                                  handleChange({
                                    target: {
                                      name: "phone",
                                      value: phoneWithoutCode,
                                    },
                                  });
                                }
                              }}
                              displayEmpty
                              renderValue={() => (
                                <Box display="flex" alignItems="center">
                                  <span
                                    style={{ marginRight: 4, fontSize: 16 }}
                                  >
                                    {selectedCountry.flag}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: 14,
                                      fontWeight: 500,
                                      color: "#333",
                                    }}
                                  >
                                    {selectedCountry.dial_code}
                                  </span>
                                </Box>
                              )}
                              MenuProps={{
                                anchorOrigin: {
                                  vertical: "bottom",
                                  horizontal: "left",
                                },
                                transformOrigin: {
                                  vertical: "top",
                                  horizontal: "left",
                                },
                                getContentAnchorEl: null,
                                PaperProps: {
                                  className: classes.mobileMenuPaper,
                                },
                                disableRestoreFocus: true,
                                autoFocus: false,
                              }}
                              style={{
                                width: "auto",
                                height: "100%",
                                padding: "0",
                                border: "none",
                                boxShadow: "none",
                                paddingTop: "0px",
                              }}
                              disableUnderline={true}
                            >
                              <MenuItem
                                disableRipple
                                disableTouchRipple
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 10,
                                  backgroundColor: "white",
                                  opacity: 1,
                                }}
                                onClick={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                                onKeyDown={(e) =>
                                  e.nativeEvent.stopImmediatePropagation()
                                }
                              >
                                <TextField
                                  fullWidth
                                  placeholder="Search country..."
                                  value={countrySearch}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    setCountrySearch(e.target.value);
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                  onKeyDown={(e) =>
                                    e.nativeEvent.stopImmediatePropagation()
                                  }
                                  variant="standard"
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                      </InputAdornment>
                                    ),
                                  }}
                                  style={{
                                    padding: "4px 12px",
                                    borderRadius: "6px",
                                  }}
                                />
                              </MenuItem>
                              {filteredCountries.length > 0 ? (
                                filteredCountries.map((country) => (
                                  <MenuItem
                                    key={country.code}
                                    value={country.code}
                                    style={{ minHeight: "40px" }}
                                  >
                                    <Box display="flex" alignItems="center">
                                      <span
                                        style={{ marginRight: 8, fontSize: 16 }}
                                      >
                                        {country.flag}
                                      </span>
                                      <span style={{ fontSize: 14 }}>
                                        {country.name}
                                      </span>
                                      <span
                                        style={{
                                          marginLeft: 8,
                                          color: "#666",
                                          fontSize: 14,
                                        }}
                                      >
                                        {country.dial_code}
                                      </span>
                                    </Box>
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>No countries found</MenuItem>
                              )}
                            </Select>
                          </Box>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Box>

              <Typography variant="body2" className={classes.formFieldLabel}>
                {leadFormConfig.organizationNameLabel || "Organisation Name"}*
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                required
                placeholder={
                  leadFormConfig.organizationNamePlaceholder ||
                  "Enter your organization name"
                }
                name="organizationName"
                value={formData.organizationName}
                onChange={handleChange}
                className={classes.formField}
                error={!!validationErrors.organizationName}
                helperText={validationErrors.organizationName}
                InputLabelProps={{ shrink: false }}
              />

              {!leadFormConfig.hideIndustry && (
                <>
                  <Typography
                    variant="body2"
                    className={classes.formFieldLabel}
                  >
                    Industry*
                  </Typography>
                  <Autocomplete
                    id="industry-autocomplete"
                    options={defaultIndustries}
                    disableClearable={true}
                    value={formData.industry || null}
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "industry",
                          value: newValue || "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        fullWidth
                        error={!!validationErrors.industry}
                        helperText={validationErrors.industry}
                        placeholder="Select your industry"
                      />
                    )}
                    className={`${classes.formField} ${classes.autocompleteInput}`}
                    ListboxProps={{
                      style: { maxHeight: "35vh" },
                    }}
                    PopperProps={{
                      style: { width: "100%" },
                    }}
                  />
                </>
              )}

              {!leadFormConfig.hideOrganizationSize && (
                <>
                  <Typography
                    variant="body2"
                    className={classes.formFieldLabel}
                  >
                    Your Organisation Size*
                  </Typography>

                  <Box className={classes.radioGroup}>
                    {defaultOrganizationSizes.map((size) => (
                      <Box key={size} className={classes.radioButton}>
                        <label
                          className={`${classes.radioLabel} ${
                            formData.organizationSize === size
                              ? classes.radioLabelSelected
                              : ""
                          }`}
                        >
                          <Radio
                            checked={formData.organizationSize === size}
                            onChange={() =>
                              handleChange({
                                target: {
                                  name: "organizationSize",
                                  value: size,
                                },
                              })
                            }
                            className={classes.radioRoot}
                            color="primary"
                            size="small"
                          />
                          <Typography variant="body2">{size}</Typography>
                        </label>
                      </Box>
                    ))}
                  </Box>

                  {validationErrors.organizationSize && (
                    <Typography className={classes.radioErrorText}>
                      {validationErrors.organizationSize}
                    </Typography>
                  )}
                </>
              )}

              <Button
                fullWidth
                className={classes.proceedButton}
                onClick={handleProceed}
                disabled={formSubmitting}
                style={{
                  marginTop: "0px",
                  backgroundColor: "#04cf66",
                  color: "white",
                  padding: "12px",
                  fontSize: "16px",
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: "4px",
                }}
              >
                {formSubmitting ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Continue to Payment"
                )}
              </Button>
            </Box>
          </Grid>
        </Grid>
      )}

      {/* Mobile layout */}
      {isMobile && (
        <Box className={classes.mobileFormContainer}>
          <Box className={classes.headerLogo}>
            <img
              src={AiSensyLogo}
              alt="AiSensy Logo"
              className={classes.logo}
            />
            {pageConfig.isCobranded && pageConfig.partnerName === "8Views" && (
              <>
                <span className={classes.partnerSeparator}>×</span>
                <img
                  src={partnerLogo8Views}
                  alt="8Views Logo"
                  className={classes.partnerLogo}
                  style={{ height: "45px" }}
                />
              </>
            )}
            {pageConfig.isCobranded &&
              pageConfig.partnerLogo &&
              pageConfig.partnerName !== "8Views" && (
                <>
                  <span className={classes.partnerSeparator}>×</span>
                  <img
                    src={pageConfig.partnerLogo}
                    alt={`${pageConfig.partnerName} Logo`}
                    className={classes.partnerLogo}
                  />
                </>
              )}
          </Box>
          {pageConfig.isCobranded && (
            <Box
              className={classes.partnershipBadge}
              style={{ marginBottom: "12px" }}
            >
              <Typography variant="caption" className={classes.badgeText}>
                In Partnership with {pageConfig.partnerName}
              </Typography>
            </Box>
          )}

          <Typography
            variant="h4"
            className={classes.pageTitle}
            style={{
              fontSize: "24px",
              fontWeight: 700,
              marginBottom: "12px",
            }}
          >
            {isAdsRegion ? (
              pageConfig.title
            ) : pageConfig.heroTitle ? (
              pageConfig.heroTitle
            ) : (
              <>
                Your First Step to <span style={{ color: "#04cf66" }}>5x</span>{" "}
                Business Engagement with AI
              </>
            )}
          </Typography>

          {/* <Box
            className={classes.featureBadges}
            style={{ marginBottom: "18px" }}
          >
            <Chip
              icon={<WhatsAppIcon className={classes.customIcon} />}
              label="WhatsApp"
              className={classes.whatsappChip}
              size="small"
            />
            <Chip
              icon={<AIIcon className={classes.customIcon} />}
              label="AI-Powered"
              className={classes.aiChip}
              size="small"
            />
            <Chip
              icon={<BriefcaseIcon className={classes.customIcon} />}
              label="Business"
              className={classes.businessChip}
              size="small"
            />
          </Box> */}

          {/* Form title */}
          {/* <Typography variant="h5" style={{ 
            marginBottom: '18px', 
            fontSize: '20px',
            fontWeight: 600,
            borderBottom: '3px solid #04cf66',
            paddingBottom: '8px',
            display: 'inline-block',
            width: '40%'
          }}>
            Tell Us About Your Busines
          </Typography> */}

          {/* Form fields without background */}
          <Box>
            <Typography variant="body2" className={classes.formFieldLabel}>
              Name*
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              required
              placeholder="Enter your full name"
              name="fullName"
              value={formData.fullName}
              onChange={(e) => {
                const value = e.target.value;
                const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
                handleChange({
                  target: {
                    name: "fullName",
                    value: sanitizedValue,
                  },
                });
              }}
              className={classes.formField}
              error={!!validationErrors.fullName}
              helperText={validationErrors.fullName}
              InputLabelProps={{ shrink: false }}
            />

            <Typography variant="body2" className={classes.formFieldLabel}>
              Email Address*
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              required
              type="email"
              placeholder="Enter your email address"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={classes.formField}
              error={!!validationErrors.email}
              helperText={validationErrors.email}
              InputLabelProps={{ shrink: false }}
            />

            <Box position="relative">
              <Typography variant="body2" className={classes.formFieldLabel}>
                Phone Number*
              </Typography>
              <Box className={classes.phoneInputContainer}>
                <TextField
                  fullWidth
                  variant="outlined"
                  required
                  placeholder="Enter your phone number"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^0-9]/g, "");
                    handleChange({
                      target: {
                        name: "phone",
                        value: numericValue,
                      },
                    });
                  }}
                  className={classes.formField}
                  error={!!validationErrors.phone}
                  helperText={validationErrors.phone}
                  InputLabelProps={{ shrink: false }}
                  type="tel"
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    ...(aeMobileOnly ? { maxLength: 10 } : {}),
                  }}
                  InputProps={{
                    startAdornment: aeMobileOnly ? aePhonePrefix : (
                      <InputAdornment
                        position="start"
                        style={{ marginRight: 0 }}
                      >
                        <Box className={classes.countryCodeInput}>
                          <Select
                            id="countrySelectMobile"
                            value={selectedCountry.code}
                            onChange={(e) => {
                              const country = countryData.find(
                                (c) => c.code === e.target.value,
                              );
                              if (country) {
                                setSelectedCountry(country);
                                const phoneWithoutCode = formData.phone.replace(
                                  /^\+\d+/,
                                  "",
                                );
                                handleChange({
                                  target: {
                                    name: "phone",
                                    value: phoneWithoutCode,
                                  },
                                });
                              }
                            }}
                            displayEmpty
                            renderValue={() => (
                              <Box display="flex" alignItems="center">
                                <span style={{ marginRight: 4, fontSize: 16 }}>
                                  {selectedCountry.flag}
                                </span>
                                <span
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: "#333",
                                  }}
                                >
                                  {selectedCountry.dial_code}
                                </span>
                              </Box>
                            )}
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                              },
                              getContentAnchorEl: null,
                              PaperProps: {
                                className: classes.mobileMenuPaper,
                              },
                              disableRestoreFocus: true,
                              autoFocus: false,
                            }}
                            style={{
                              width: "auto",
                              height: "100%",
                              padding: "0",
                              border: "none",
                              boxShadow: "none",
                            }}
                            disableUnderline={true}
                          >
                            <MenuItem
                              disableRipple
                              disableTouchRipple
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 10,
                                backgroundColor: "white",
                                opacity: 1,
                              }}
                              onClick={(e) => e.stopPropagation()}
                              onMouseDown={(e) => e.stopPropagation()}
                              onKeyDown={(e) =>
                                e.nativeEvent.stopImmediatePropagation()
                              }
                            >
                              <TextField
                                fullWidth
                                placeholder="Search country..."
                                value={countrySearch}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  setCountrySearch(e.target.value);
                                }}
                                onClick={(e) => e.stopPropagation()}
                                onKeyDown={(e) =>
                                  e.nativeEvent.stopImmediatePropagation()
                                }
                                variant="standard"
                                size="small"
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                  ),
                                }}
                                style={{
                                  borderRadius: "6px",
                                  padding: "4px 12px",
                                }}
                              />
                            </MenuItem>
                            {filteredCountries.length > 0 ? (
                              filteredCountries.map((country) => (
                                <MenuItem
                                  key={country.code}
                                  value={country.code}
                                  style={{ minHeight: "40px" }}
                                >
                                  <Box display="flex" alignItems="center">
                                    <span
                                      style={{ marginRight: 8, fontSize: 16 }}
                                    >
                                      {country.flag}
                                    </span>
                                    <span style={{ fontSize: 14 }}>
                                      {country.name}
                                    </span>
                                    <span
                                      style={{
                                        marginLeft: 8,
                                        color: "#666",
                                        fontSize: 14,
                                      }}
                                    >
                                      {country.dial_code}
                                    </span>
                                  </Box>
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>No countries found</MenuItem>
                            )}
                          </Select>
                        </Box>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>

            <Typography variant="body2" className={classes.formFieldLabel}>
              {leadFormConfig.organizationNameLabel || "Organisation Name"}*
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              required
              placeholder={
                leadFormConfig.organizationNamePlaceholder ||
                "Enter your organization name"
              }
              name="organizationName"
              value={formData.organizationName}
              onChange={handleChange}
              className={classes.formField}
              error={!!validationErrors.organizationName}
              helperText={validationErrors.organizationName}
              InputLabelProps={{ shrink: false }}
            />

            {!leadFormConfig.hideIndustry && (
              <>
                <Typography variant="body2" className={classes.formFieldLabel}>
                  Industry*
                </Typography>
                <Autocomplete
                  id="industry-autocomplete-mobile" // Target this specific Autocomplete
                  options={defaultIndustries}
                  value={formData.industry || null}
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "industry",
                        value: newValue || "",
                      },
                    });
                  }}
                  disableClearable={true} // Add this prop to remove the clear icon
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      fullWidth
                      error={!!validationErrors.industry}
                      helperText={validationErrors.industry}
                      placeholder="Select your industry"
                      InputProps={{
                        ...params.InputProps, // Preserve existing InputProps from Autocomplete
                        style: { paddingTop: "8px", paddingBottom: "8px" }, // Keep existing height adjustment
                      }}
                      inputProps={{
                        // Use inputProps (lowercase i) for native input attributes
                        ...params.inputProps, // Preserve existing inputProps from Autocomplete
                        readOnly: true, // Add this to prevent keyboard
                      }}
                    />
                  )}
                  className={`${classes.formField} ${classes.autocompleteInput}`}
                  ListboxProps={{
                    style: { maxHeight: "35vh" },
                  }}
                  PopperProps={{
                    style: { width: "100%" },
                  }}
                />
              </>
            )}

            {!leadFormConfig.hideOrganizationSize && (
              <>
                <Typography variant="body2" className={classes.formFieldLabel}>
                  Your Organisation Size*
                </Typography>
                <Box className={classes.radioGroup}>
                  {defaultOrganizationSizes.map((size) => (
                    <Box key={size} className={classes.radioButton}>
                      <label
                        className={`${classes.radioLabel} ${
                          formData.organizationSize === size
                            ? classes.radioLabelSelected
                            : ""
                        }`}
                      >
                        <Radio
                          checked={formData.organizationSize === size}
                          onChange={() =>
                            handleChange({
                              target: {
                                name: "organizationSize",
                                value: size,
                              },
                            })
                          }
                          className={classes.radioRoot}
                          color="primary"
                          size="small"
                        />
                        <Typography variant="body2">{size}</Typography>
                      </label>
                    </Box>
                  ))}
                </Box>
                {validationErrors.organizationSize && (
                  <Typography className={classes.radioErrorText}>
                    {validationErrors.organizationSize}
                  </Typography>
                )}
              </>
            )}
          </Box>

          {/* Benefits section */}
          <Box
            className={classes.sideContentPaper}
            style={{ marginTop: "24px", backgroundColor: "transparent" }}
          >
            <Typography
              variant="h6"
              gutterBottom
              className={classes.sideContentTitle}
              style={{ marginBottom: "4px" }}
            >
              {isAdsRegion
                ? pageConfig.subtitle
                : pageConfig.sidebarTitle ||
                  "Why Choose AiSensy for WhatsApp Business?"}
            </Typography>

            {/* Benefits */}
            {(pageConfig.benefits?.length > 0
              ? pageConfig.benefits
              : [
                  {
                    title: "Official WhatsApp Business API Partner",
                    description:
                      "Get verified WhatsApp Business account with green tick",
                  },
                  {
                    title: "Powerful AI Chatbots",
                    description:
                      "Create no-code WhatsApp chatbots to automate customer support",
                  },
                  {
                    title: "Broadcasts & Campaigns",
                    description:
                      "Send personalized messages to thousands of customers instantly",
                  },
                  {
                    title: "Seamless CRM Integration",
                    description:
                      "Connect with your existing tools and workflows",
                  },
                ]
            ).map((benefit, index) => (
              <Box key={index} className={classes.benefitItem}>
                <CheckCircleIcon className={classes.benefitIcon} />
                <Box>
                  <Typography
                    variant="subtitle2"
                    className={classes.benefitTitle}
                  >
                    {benefit.title}
                  </Typography>
                  <Typography variant="body2" className={classes.benefitDesc}>
                    {benefit.description}
                  </Typography>
                </Box>
              </Box>
            ))}

            {/* Testimonial */}
            {/* <Box
              className={classes.testimonial}
              style={{ marginTop: "18px", width: "95%" }}
            >
              <Typography variant="body2" className={classes.testimonialText}>
                "
                {pageConfig.testimonial?.quote ||
                  "AiSensy has transformed how we connect with customers. The results speak for themselves - 40% increase in response rates!"}
                "
              </Typography>
              <Box className={classes.testimonialAuthor}>
                <Avatar
                  src={
                    pageConfig.testimonial?.avatar ||
                    "https://randomuser.me/api/portraits/men/36.jpg"
                  }
                  className={classes.testimonialAvatar}
                />
                <Box>
                  <Typography variant="subtitle2">
                    {pageConfig.testimonial?.name || "Ahmed Hassan"}
                  </Typography>
                  <Typography variant="caption">
                    {pageConfig.testimonial?.position ||
                      "Marketing Director, TeknoPros"}
                  </Typography>
                </Box>
              </Box>
            </Box> */}
          </Box>

          {/* Sticky button for mobile */}
          <Box className={classes.stickyBottomBar}>
            <Box>
              <Typography
                className={classes.mobileButtonText}
                style={{ fontWeight: 600 }}
              >
                <span style={{ color: "#04cf66" }}>Limited-Time Offer!</span>
              </Typography>
              {/* <Typography className={classes.mobileTotalAmount}>
                <CountUp end={98} suffix="% of businesses see ROI in 30 days" duration={2} />
              </Typography> */}
            </Box>
            <Button
              className={classes.mobileProceedButton}
              onClick={handleProceed}
              disabled={formSubmitting}
              endIcon={!formSubmitting && <ArrowRight />}
            >
              {formSubmitting ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Continue to Payment"
              )}
            </Button>
          </Box>
        </Box>
      )}
    </Container>
  );

  // Modify renderPlansStep to create a better UI similar to PaymentPage.js
  const renderPlansStep = () => {
    // Handle error cases (keep existing code)
    if (apiError) {
      return (
        <Container className={classes.container} maxWidth="md">
          <Box className={classes.headerLogo}>
            <img
              src={AiSensyLogo}
              alt="AiSensy Logo"
              className={classes.logo}
            />
          </Box>

          <Paper elevation={0} className={classes.formContainer}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              p={4}
            >
              <Typography variant="h5" gutterBottom>
                Something Went Wrong
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                We're having a little trouble loading your plans—no worries,
                this is usually resolved quickly!
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Please{" "}
                <a
                  href="https://aisensy.com/contact-us"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#04cf66",
                    fontWeight: 600,
                    textDecoration: "none",
                  }}
                >
                  contact our support team
                </a>{" "}
                and we'll help you get started.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBack}
                className={classes.proceedButton}
                startIcon={<ArrowBackIcon />}
              >
                Back to Previous Step
              </Button>
            </Box>
          </Paper>
        </Container>
      );
    }

    // No plans found - unusual error case
    if (!plans || plans.length === 0) {
      return (
        <Container className={classes.container} maxWidth="md">
          <Box className={classes.headerLogo}>
            <img
              src={AiSensyLogo}
              alt="AiSensy Logo"
              className={classes.logo}
            />
          </Box>

          <Paper elevation={0} className={classes.formContainer}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              p={4}
            >
              <Typography variant="h5" gutterBottom>
                No Plans Available
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                There are currently no plans available for this region.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBack}
                className={classes.proceedButton}
                startIcon={<ArrowBackIcon />}
              >
                Back to Previous Step
              </Button>
            </Box>
          </Paper>
        </Container>
      );
    }

    const handleAddToCart = (plan) => {
      // Track plan selection
      posthog.capture("plan_added_to_cart", {
        plan_id: plan.id,
        plan_name: plan.name,
        plan_price: plan.price,
        billing_period: billingPeriod,
        region: region,
      });

      // If only one plan exists, keep it always selected (no unselect)
      if (plans.length === 1) {
        setCart([{ ...plan, quantity: 1 }]);
        return;
      }
      // Check if this is a different plan than what's currently in the cart
      const currentPlanId = cart.length > 0 ? cart[0].id : null;
      const isChangingPlan =
        currentPlanId !== null && currentPlanId !== plan.id;

      // Create the new cart
      const newCart = [];
      if (!isPlanInCart(plan.id)) {
        newCart.push({ ...plan, quantity: 1 });
      }

      // If the cart becomes empty (plan was deselected) or plan is changed
      if (newCart.length === 0 || isChangingPlan) {
        // Reset coupon details
        setCouponApplied(false);
        setCouponCode("");
        setCouponMessage("");
        setCouponData(null);
        setDiscount(0);

        // If plan was deselected, also reset addon selections
        if (newCart.length === 0) {
          setAddons(
            addons.map((addon) => ({
              ...addon,
              selected: false,
            })),
          );
        }
      }

      setCart(newCart);
    };

    const isPlanInCart = (planId) => {
      return cart.some((item) => item.id === planId);
    };

    // Define a function to render a single plan card
    const renderPlanCard = (plan) => {
      const isExpanded = expandedFeatures[plan.id] || false;
      // Features shown above the "See more" expander (config-overridable).
      const visibleFeatureCount = pageConfig.initialFeaturesCount || 4;
      // Ads region shows the full feature list inline — no "See more" expander.
      const hasMoreFeatures =
        !isAdsRegion &&
        Array.isArray(plan.features) &&
        plan.features.length > visibleFeatureCount;

      const filteredFeatures = Array.isArray(plan.features)
        ? plan.features
        : [];
      const initialFeatures = isAdsRegion
        ? filteredFeatures
        : filteredFeatures.slice(0, visibleFeatureCount);
      const extraFeatures =
        Array.isArray(filteredFeatures) && hasMoreFeatures
          ? filteredFeatures.slice(visibleFeatureCount)
          : [];

      const toggleFeatures = (e) => {
        e.stopPropagation();
        setExpandedFeatures({
          ...expandedFeatures,
          [plan.id]: !isExpanded,
        });
      };

      // Calculate discount percentage
      const calculateDiscountPercentage = () => {
        if (plan.originalPrice && plan.originalPrice > plan.price) {
          const discount = plan.originalPrice - plan.price;
          const percentage = (discount / plan.originalPrice) * 100;
          let roundedPercentage = Math.round(percentage);

          // Round specific percentages for better presentation
          if (roundedPercentage === 31) roundedPercentage = 30;
          if (roundedPercentage === 26) roundedPercentage = 25;

          return roundedPercentage;
        }
        return null;
      };

      const discountPercentage = calculateDiscountPercentage();

      return (
        <Card
          className={`${classes.planCard} ${
            isPlanInCart(plan.id) ? classes.selectedPlan : ""
          } ${isAdsRegion ? classes.tightPlanCard : ""}`}
        >
          <Box className={classes.planHeader}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <Typography className={classes.planTitle}>
                {plan.title}
              </Typography>
              {!isAdsRegion && (discountPercentage || plan.saving) && (
                <Chip
                  label={
                    // No originalPrice in pricing config → discountPercentage
                    // is null; fall back to the saving text instead of
                    // rendering "null% OFF".
                    isBundleOffer || !discountPercentage
                      ? plan.saving
                      : `${discountPercentage}% OFF`
                  }
                  className={classes.discountChip}
                  size="small"
                />
              )}
              {plan.spotsLeft && (
                <span className={classes.spotsLeft}>
                  <WarningIcon className={classes.warningIcon} />
                  {plan.spotsLeft} spots left
                </span>
              )}
            </Box>
          </Box>

          {isAdsRegion && plan.leadsHighlight && (
            <Box className={classes.leadsHighlight}>
              <TrendingUpIcon className={classes.leadsHighlightIcon} />
              <span className={classes.leadsHighlightText}>
                {plan.leadsHighlight}
              </span>
            </Box>
          )}

          {isAdsRegion ? (
            <Box className={classes.adsBreakdown}>
              <Typography className={classes.adsBreakdownTitle}>
                Ad Credits Breakdown
              </Typography>
              <Box className={classes.adsBreakdownRow}>
                <span className={classes.adsBreakdownLabel}>You Pay</span>
                <span className={classes.adsBreakdownValue}>
                  {pageConfig.currencySymbol}
                  {plan.price?.toLocaleString("en-IN")}
                </span>
              </Box>
              {plan.originalPrice && plan.originalPrice > plan.price && (
                <Box className={classes.adsBreakdownRow}>
                  <span className={classes.adsBreakdownLabel}>
                    Extra Credits
                  </span>
                  <span className={classes.adsBreakdownExtra}>
                    + {pageConfig.currencySymbol}
                    {(plan.originalPrice - plan.price).toLocaleString("en-IN")}
                  </span>
                </Box>
              )}
              <Box className={classes.adsBreakdownDivider} />
              <Box className={classes.adsBreakdownRow}>
                <span className={classes.adsBreakdownTotalLabel}>
                  Total Ad Credits
                </span>
                <span className={classes.adsBreakdownTotalValue}>
                  {pageConfig.currencySymbol}
                  {(plan.originalPrice || plan.price)?.toLocaleString("en-IN")}
                </span>
              </Box>
              {plan.dailyBudget && (
                <Typography className={classes.adsBreakdownCaption}>
                  Daily Budget: ~{plan.dailyBudget}
                </Typography>
              )}
            </Box>
          ) : (
            <Typography className={classes.planSubtitle}>
              {plan.subtitle}
            </Typography>
          )}

          {false && (
            <List className={classes.featureList} dense>
              {initialFeatures.map((feature, index) => (
                <ListItem key={index} className={classes.featureItem}>
                  <ListItemIcon className={classes.featureIcon}>
                    <CheckIcon className={classes.featureCheck} />
                  </ListItemIcon>
                  <ListItemText
                    primary={feature}
                    className={classes.featureText}
                    primaryTypographyProps={{
                      style: { fontSize: "13px" },
                    }}
                  />
                </ListItem>
              ))}
            </List>
          )}

          {/* Itemized bundle breakdown — hidden for ads region: a single
              "5,000 Ad Credits ₹5000" line duplicates the card title and
              the price footer, so we keep just the feature ticks below. */}
          {!isAdsRegion &&
            Array.isArray(plan.items) &&
            plan.items.length > 0 && (
              <Box>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: 600, marginBottom: 4 }}
                >
                  What's included
                </Typography>
                <List dense className={classes.featureList}>
                  {plan.items.map((it, idx) => (
                    <ListItem key={idx} className={classes.featureItem}>
                      <ListItemIcon className={classes.featureIcon}>
                        <CheckIcon className={classes.featureCheck} />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Box display="flex" justifyContent="space-between">
                            <span>{it.title}</span>
                            {!isBundleOffer && (
                              <span>
                                {it.originalPrice &&
                                  it.originalPrice > it.price && (
                                    <span className={classes.originalPrice}>
                                      {pageConfig.currencySymbol}
                                      {it.originalPrice}
                                    </span>
                                  )}
                                {pageConfig.currencySymbol}
                                {it.price}
                              </span>
                            )}
                          </Box>
                        }
                        className={classes.featureText}
                        primaryTypographyProps={{ style: { fontSize: 13 } }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}

          {!isAdsRegion && <Divider className={classes.divider} />}

          {/* Re-positioned features list after What's included */}
          {initialFeatures.length > 0 && (
            <List className={classes.featureList} dense>
              {initialFeatures.map((feature, index) => (
                <ListItem key={index} className={classes.featureItem}>
                  <ListItemIcon className={classes.featureIcon}>
                    <CheckIcon className={classes.featureCheck} />
                  </ListItemIcon>
                  <ListItemText
                    primary={feature}
                    className={classes.featureText}
                    primaryTypographyProps={{
                      style: { fontSize: "13px" },
                    }}
                  />
                </ListItem>
              ))}
            </List>
          )}

          {hasMoreFeatures && (
            <div>
              <Button
                onClick={toggleFeatures}
                className={classes.seeMoreButton}
                endIcon={
                  isExpanded ? (
                    <ExpandLessIcon fontSize="small" />
                  ) : (
                    <ExpandMoreIcon fontSize="small" />
                  )
                }
              >
                {isExpanded ? "See less" : `See more features`}
              </Button>

              {isExpanded && (
                <List className={classes.featureList} dense>
                  {extraFeatures.map((feature, index) => (
                    <ListItem key={index} className={classes.featureItem}>
                      <ListItemIcon className={classes.featureIcon}>
                        <CheckIcon className={classes.featureCheck} />
                      </ListItemIcon>
                      <ListItemText
                        primary={feature}
                        className={classes.featureText}
                        primaryTypographyProps={{
                          style: { fontSize: "13px" },
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </div>
          )}

          <Divider className={classes.divider} />

          <Box className={classes.passActions}>
            <Box>
              <Typography className={classes.planPriceBottom}>
                {plan.originalPrice && plan.originalPrice > plan.price && (
                  <span className={classes.originalPrice}>
                    {pageConfig.currencySymbol}
                    {plan.originalPrice}
                  </span>
                )}
                {pageConfig.currencySymbol}
                {plan.price}
                {pageConfig.gstPercentage && pageConfig.gstPercentage > 0 && (
                  <Typography
                    variant="caption"
                    style={{
                      fontSize: "12px",
                      color: "#555",
                      marginLeft: "4px",
                    }}
                  >
                    +{pageConfig.gstPercentage}% GST
                  </Typography>
                )}
              </Typography>
              {!isAdsRegion && (
                <Typography
                  variant="caption"
                  className={classes.billingPeriodText}
                >
                  {(() => {
                    const effectivePeriod =
                      plan.fixedBillingPeriod || billingPeriod;
                    const billedText =
                      pageConfig.planOptions[effectivePeriod] &&
                      pageConfig.planOptions[effectivePeriod][plan.id]
                        ? pageConfig.planOptions[effectivePeriod][plan.id]
                            .billed
                        : effectivePeriod;
                    return `(${`Billed ${billedText}`})`;
                  })()}
                </Typography>
              )}
            </Box>
            {isPlanInCart(plan.id) ? (
              <Button
                className={classes.selectedButton}
                startIcon={<CheckCircleIcon />}
              >
                Selected
              </Button>
            ) : (
              <Button
                className={classes.selectButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddToCart(plan);
                }}
              >
                {isAdsRegion ? "Select" : "Add to Cart"}
              </Button>
            )}
          </Box>
        </Card>
      );
    };

    return (
      <div>
        <Container
          className={classes.container}
          maxWidth="lg"
          style={{
            paddingBottom: isMobile ? "0px" : undefined,
          }}
        >
          <Box className={classes.headerLogo}>
            <img
              src={AiSensyLogo}
              alt="AiSensy Logo"
              className={classes.logo}
            />
            {pageConfig.isCobranded && pageConfig.partnerName === "8Views" && (
              <>
                <span className={classes.partnerSeparator}>×</span>
                <img
                  src={partnerLogo8Views}
                  alt="8Views Logo"
                  className={classes.partnerLogo}
                  style={{ height: "45px" }}
                />
              </>
            )}
            {pageConfig.isCobranded &&
              pageConfig.partnerLogo &&
              pageConfig.partnerName !== "8Views" && (
                <>
                  <span className={classes.partnerSeparator}>×</span>
                  <img
                    src={pageConfig.partnerLogo}
                    alt={`${pageConfig.partnerName} Logo`}
                    className={classes.partnerLogo}
                  />
                </>
              )}
          </Box>
          {pageConfig.isCobranded && (
            <Box
              className={classes.partnershipBadge}
              style={{ marginBottom: "12px" }}
            >
              <Typography variant="caption" className={classes.badgeText}>
                Exclusive Partnership Offer with {pageConfig.partnerName}
              </Typography>
            </Box>
          )}

          <Box>
            <Typography
              variant="h5"
              className={classes.pageTitle}
              style={{ marginBottom: isAdsRegion ? "6px" : "18px" }}
            >
              {pageConfig.plansTitle || "Choose Your WhatsApp Business Plan"}
            </Typography>
            {isAdsRegion && (
              <Typography
                className={classes.adsTrustTagline}
                style={{ marginBottom: "18px" }}
              >
                Easy to use platform
                <span className={classes.adsTrustTaglineDot}>•</span>
                Trusted by 210,000+ Businesses
              </Typography>
            )}

            {/* Feature badges in a row
            <Box
              className={classes.featureBadges}
              style={{ marginBottom: "18px" }}
            >
              <Chip
                icon={<WhatsAppIcon className={classes.customIcon} />}
                label="WhatsApp"
                className={classes.whatsappChip}
                size="medium"
              />
              <Chip
                icon={<AIIcon className={classes.customIcon} />}
                label="AI-Powered"
                className={classes.aiChip}
                size="medium"
              />
              <Chip
                icon={<BriefcaseIcon className={classes.customIcon} />}
                label="Business"
                className={classes.businessChip}
                size="medium"
              />
            </Box> */}

            {/* Billing cycle toggle moved near the page title */}
            {Object.keys(pageConfig.planOptions).length > 1 &&
              !pageConfig.hideGlobalBillingToggle && (
                <Box className={classes.billingToggleContainer}>
                  <ToggleButtonGroup
                    value={billingPeriod}
                    exclusive
                    onChange={handleBillingPeriodChange}
                    className={classes.toggleContainer}
                    style={{
                      "--active-index": Object.keys(
                        pageConfig.planOptions,
                      ).indexOf(billingPeriod),
                      "--total-items": Object.keys(pageConfig.planOptions)
                        .length,
                    }}
                    size="medium"
                  >
                    {Object.keys(pageConfig.planOptions).map((period) => {
                      const isDisabled = plans.every(
                        (p) =>
                          p.fixedBillingPeriod &&
                          p.fixedBillingPeriod !== period,
                      );
                      return (
                        <ToggleButton
                          key={period}
                          value={period}
                          className={classes.toggleButton}
                          disabled={isDisabled}
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                          >
                            <span
                              style={{
                                fontWeight:
                                  billingPeriod === period ? 600 : 500,
                              }}
                            >
                              {pageConfig.planOptions[period].label}
                            </span>
                            {pageConfig.planOptions[period].savingBadge && (
                              <span className={classes.savingBadgeToggle}>
                                Save{" "}
                                {pageConfig.planOptions[period].savingBadge}
                              </span>
                            )}
                          </Box>
                        </ToggleButton>
                      );
                    })}
                  </ToggleButtonGroup>
                </Box>
              )}
          </Box>

          <Grid container spacing={3}>
            {/* Left side - Plans - Now 60% width on desktop */}
            <Grid item xs={12} md={7}>
              {/* Compact stack for ads — paired with tightPlanCard
                  (which zeroes the per-card marginBottom) so the gap is
                  driven by Grid spacing alone. */}
              <Grid container spacing={2}>
                {plans.map((plan) => (
                  <Grid
                    item
                    xs={12}
                    key={plan.id}
                    onClick={() => handleAddToCart(plan)}
                  >
                    {renderPlanCard(plan)}
                  </Grid>
                ))}
              </Grid>
              {isMobile && (!addons || addons.length === 0) && (
                <Box style={{ height: theme.spacing(12) }} aria-hidden />
              )}

              {/* Add-ons Section */}
              {addons && addons.length > 0 && (
                <Box
                  mt={1}
                  style={{
                    marginBottom: isMobile ? theme.spacing(10) : undefined,
                  }}
                >
                  <Typography variant="h6" className={classes.sectionTitle}>
                    Add-ons
                  </Typography>

                  <Grid container spacing={2}>
                    {addons.map((addon) => (
                      <Grid item xs={12} key={addon.id}>
                        <Tooltip
                          title={
                            cart.length === 0
                              ? "Please select a plan first to enable add-ons"
                              : ""
                          }
                          placement="top"
                          open={
                            isMobile ? openTooltipId === addon.id : undefined
                          }
                          onClose={() => setOpenTooltipId(null)}
                          arrow
                          classes={{
                            tooltip: classes.addonTooltip,
                          }}
                          enterTouchDelay={0}
                          leaveTouchDelay={3000}
                        >
                          <Box
                            className={`${classes.addonCard} ${
                              addon.selected ? classes.addonSelected : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              // For mobile, toggle tooltip on click when no plan is selected
                              if (isMobile && cart.length === 0) {
                                setOpenTooltipId(
                                  openTooltipId === addon.id ? null : addon.id,
                                );
                                return;
                              }

                              // When a plan is selected, toggle the addon selection
                              if (cart.length > 0) {
                                // Update the addons and reset coupon
                                setAddons(
                                  addons.map((a) => ({
                                    ...a,
                                    selected:
                                      a.id === addon.id
                                        ? !a.selected
                                        : a.selected,
                                  })),
                                );

                                // Reset coupon when addon selection changes
                                setCouponApplied(false);
                                setCouponCode("");
                                setCouponMessage("");
                                setCouponData(null);
                                setDiscount(0);
                              } else {
                                // Show error message if trying to select addon without a plan
                                setError(
                                  "Please select a plan before adding any add-ons",
                                );
                                setShowError(true);
                              }
                            }}
                          >
                            <Box className={classes.addonContent}>
                              <Checkbox
                                checked={addon.selected}
                                onChange={(e) => {
                                  // Just stop propagation as the parent card's onClick will handle selection
                                  e.stopPropagation();
                                }}
                                className={classes.addonCheckbox}
                                color="primary"
                              />
                              <Box className={classes.addonInfo}>
                                <Typography className={classes.addonName}>
                                  {addon.title}
                                </Typography>
                                <Typography
                                  className={classes.addonDescription}
                                >
                                  {addon.description}
                                </Typography>
                              </Box>
                            </Box>
                            <Typography className={classes.addonPrice}>
                              {pageConfig.currencySymbol}
                              {addon.price}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}

              {/* Show testimonials similar to PaymentPage.js
              {!isMobile && (
                <Box mt={4} mb={2}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    What Our Customers Say
                  </Typography>

                  <Box className={classes.testimonialCard}>
                    <Typography className={classes.testimonialQuote}>
                      "AiSensy has transformed how we connect with customers. The results speak for themselves - 40% increase in response rates!"
                    </Typography>
                    <Box className={classes.testimonialAuthor}>
                      <Avatar
                        src={pageConfig.testimonial?.avatar || "https://randomuser.me/api/portraits/men/36.jpg"}
                        className={classes.testimonialAvatar}
                      />
                      <Box>
                        <Typography className={classes.testimonialName}>
                          {pageConfig.testimonial?.name || "Ahmed Hassan"}
                        </Typography>
                        <Typography className={classes.testimonialCompany}>
                          {pageConfig.testimonial?.position || "Marketing Director, TeknoPros"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box className={classes.testimonialCard}>
                    <Typography className={classes.testimonialQuote}>
                      "The implementation was incredibly smooth, and our team was able to scale our WhatsApp communications effortlessly."
                    </Typography>
                    <Box className={classes.testimonialAuthor}>
                      <Avatar src="https://randomuser.me/api/portraits/women/44.jpg" />
                      <Box>
                        <Typography className={classes.testimonialName}>
                          Sarah Johnson
                        </Typography>
                        <Typography className={classes.testimonialCompany}>
                          Customer Success Manager, Digital Solutions
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )} */}
            </Grid>

            {/* Right side - Order Summary and Add-ons - Now 40% width on desktop */}
            {!isMobile && (
              <Grid item xs={12} md={5}>
                <Card className={classes.summaryCard}>
                  <CardContent style={{ padding: "16px" }}>
                    <Typography variant="h6" className={classes.summaryTitle}>
                      Order Summary
                    </Typography>

                    {cart.length === 0 &&
                    !addons.some((addon) => addon.selected) ? (
                      <Box className={classes.emptyCartContainer}>
                        <ShoppingCartIcon className={classes.emptyCartIcon} />
                        <Typography
                          variant="body1"
                          align="center"
                          className={classes.emptyCartText}
                        >
                          Your cart is{" "}
                          <span className={classes.emptyCartHighlight}>
                            empty
                          </span>
                          !
                        </Typography>
                        <Typography
                          variant="body2"
                          align="center"
                          className={classes.emptyCartSubtext}
                        >
                          Please select a plan to continue with your WhatsApp
                          Business journey.
                        </Typography>
                      </Box>
                    ) : (
                      <>
                        {/* Summary Items */}
                        {cart.map((item) => (
                          <Box key={item.id}>
                            {isBundleOffer || isAdsRegion ? (
                              <Box className={classes.summaryItem}>
                                <Box className={classes.summaryItemDetails}>
                                  <Typography
                                    className={classes.summaryItemName}
                                  >
                                    {item.title}
                                  </Typography>
                                </Box>
                                <Typography
                                  className={classes.summaryItemPrice}
                                >
                                  {item.originalPrice &&
                                    item.originalPrice > item.price && (
                                      <span className={classes.originalPrice}>
                                        {pageConfig.currencySymbol}
                                        {item.originalPrice}
                                      </span>
                                    )}
                                  {pageConfig.currencySymbol}
                                  {item.price}
                                </Typography>
                              </Box>
                            ) : (
                              Array.isArray(item.items) &&
                              item.items.length > 0 && (
                                <Box>
                                  {item.items.map((it, idx) => (
                                    <Box
                                      key={idx}
                                      className={classes.summaryAddonItem}
                                    >
                                      <Typography
                                        className={classes.summaryAddonName}
                                      >
                                        {it.title}
                                        {/* {it.recurring === true && (
                                          <span
                                            style={{
                                              color: "#666",
                                              marginLeft: 6,
                                            }}
                                          >
                                            (recurring)
                                          </span>
                                        )} */}
                                      </Typography>
                                      <Typography
                                        className={classes.summaryItemPrice}
                                      >
                                        {it.originalPrice &&
                                          it.originalPrice > it.price && (
                                            <span
                                              className={classes.originalPrice}
                                            >
                                              {pageConfig.currencySymbol}
                                              {it.originalPrice}
                                            </span>
                                          )}
                                        {pageConfig.currencySymbol}
                                        {it.price}
                                      </Typography>
                                    </Box>
                                  ))}
                                </Box>
                              )
                            )}
                          </Box>
                        ))}

                        {/* Add-ons Section - Improved UI */}
                        {addons.filter((addon) => addon.selected).length >
                          0 && (
                          <>
                            {addons
                              .filter((addon) => addon.selected)
                              .map((addon) => (
                                <Box
                                  key={addon.id}
                                  className={classes.summaryAddonItem}
                                >
                                  <Typography
                                    className={classes.summaryAddonName}
                                  >
                                    {addon.title}
                                  </Typography>
                                  <Typography
                                    className={classes.summaryItemPrice}
                                  >
                                    {pageConfig.currencySymbol}
                                    {addon.price}
                                  </Typography>
                                </Box>
                              ))}
                          </>
                        )}

                        <Divider
                          className={classes.divider}
                          style={{ margin: "16px 0 12px" }}
                        />

                        <Box className={classes.subtotalRow}>
                          <Typography variant="body2">Subtotal</Typography>
                          <Typography
                            variant="body2"
                            style={{ fontWeight: 500 }}
                          >
                            {pageConfig.currencySymbol}
                            {getSubtotal()}
                          </Typography>
                        </Box>

                        {couponApplied && couponData && (
                          <Box
                            className={classes.subtotalRow}
                            style={{ color: "#04cf66" }}
                          >
                            <Typography
                              variant="body2"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {/* <CheckCircleIcon style={{ fontSize: 14, marginRight: 4 }} /> */}
                              Discount{" "}
                              {couponData.discountType === "percentage"
                                ? `(${couponData.discountValue}%)`
                                : ""}
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{ fontWeight: 500 }}
                            >
                              -{pageConfig.currencySymbol}
                              {parseFloat(discount).toFixed(2)}
                            </Typography>
                          </Box>
                        )}

                        {/* GST Row */}
                        {pageConfig.gstPercentage &&
                          pageConfig.gstPercentage > 0 && (
                            <Box className={classes.subtotalRow}>
                              <Typography variant="body2">
                                {pageConfig.gstLabel ||
                                  `GST (${pageConfig.gstPercentage}%)`}
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{ fontWeight: 500 }}
                              >
                                {pageConfig.currencySymbol}
                                {getGstAmount().toFixed(2)}
                              </Typography>
                            </Box>
                          )}

                        {/* Coupon Section */}
                        {!pageConfig.hideCouponSection && (
                          <div className={classes.couponSection}>
                            <Typography
                              variant="subtitle2"
                              className={classes.couponLabel}
                            >
                              Got a coupon code?
                            </Typography>
                            <div className={classes.couponInput}>
                              <TextField
                                className={classes.couponTextField}
                                variant="outlined"
                                placeholder="Enter Code"
                                value={couponCode}
                                onChange={handleCouponChange}
                                fullWidth
                                size="small"
                                inputProps={{
                                  style: { fontSize: "14px" },
                                }}
                              />
                              <Button
                                className={classes.couponButton}
                                onClick={handleApplyCoupon}
                                disabled={
                                  validatingCoupon || !couponCode.trim()
                                }
                                size="small"
                              >
                                {validatingCoupon ? (
                                  <CircularProgress size={16} color="inherit" />
                                ) : (
                                  "Apply"
                                )}
                              </Button>
                            </div>
                            {couponApplied && (
                              <Typography
                                variant="body2"
                                className={classes.successText}
                              >
                                <CheckCircleIcon
                                  className={classes.successIcon}
                                />
                                {couponMessage}
                              </Typography>
                            )}
                            {couponMessage && !couponApplied && (
                              <Typography
                                variant="body2"
                                className={classes.errorText}
                              >
                                {couponMessage}
                              </Typography>
                            )}
                          </div>
                        )}

                        {/* Total Row */}
                        <Box className={classes.totalRow}>
                          <Typography className={classes.totalLabel}>
                            Total{" "}
                            {pageConfig.gstPercentage &&
                            pageConfig.gstPercentage > 0
                              ? "(incl. GST)"
                              : ""}
                          </Typography>
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="flex-end"
                          >
                            <Box display="flex" alignItems="center">
                              {(() => {
                                // Calculate original total if items have original prices
                                let originalTotal = 0;
                                cart.forEach((item) => {
                                  if (item.originalPrice) {
                                    originalTotal += item.originalPrice;
                                  }
                                });
                                addons.forEach((addon) => {
                                  if (addon.selected && addon.originalPrice) {
                                    originalTotal += addon.originalPrice;
                                  }
                                });

                                // Add GST to original total if applicable
                                if (
                                  pageConfig.gstPercentage &&
                                  pageConfig.gstPercentage > 0 &&
                                  originalTotal > 0
                                ) {
                                  originalTotal =
                                    originalTotal +
                                    originalTotal *
                                      (pageConfig.gstPercentage / 100);
                                }

                                return originalTotal > getTotalAmount() ? (
                                  <Typography
                                    className={classes.originalPriceTotal}
                                  >
                                    {pageConfig.currencySymbol}
                                    {parseFloat(originalTotal.toFixed(2))}
                                  </Typography>
                                ) : null;
                              })()}
                              <Typography className={classes.totalAmount}>
                                {pageConfig.currencySymbol}
                                {getTotalAmount()}
                              </Typography>
                            </Box>
                            {getTotalUsdEquivalent() > 0 && (
                              <Typography className={classes.usdEquivalent}>
                                (≈ ${getTotalUsdEquivalent()})
                              </Typography>
                            )}
                          </Box>
                        </Box>

                        {/* Checkout Button */}
                        <Button
                          fullWidth
                          className={classes.proceedButton}
                          onClick={handleProceed}
                          disabled={submitting}
                        >
                          {submitting ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            pageConfig.checkoutButtonText || `Complete Purchase`
                          )}
                        </Button>
                      </>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            )}
          </Grid>

          {/* Back Button */}
          {/* <Box mt={3} display="flex" justifyContent="flex-start">
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={handleBack}
              variant="outlined"
              className={classes.backButton}
            >
              Back to Details
            </Button>
          </Box> */}
        </Container>

        {/* Mobile Sticky Bottom Bar */}
        {isMobile && hasItems() && (
          <>
            {summaryExpanded && (
              <Drawer
                anchor="bottom"
                open={summaryExpanded}
                onClose={() => setSummaryExpanded(false)}
                classes={{
                  paper: classes.mobileDrawerPaper,
                }}
              >
                <Box p={2} className={classes.mobileDrawerContent}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography
                      variant="h6"
                      style={{ fontWeight: 600, fontSize: "16px" }}
                    >
                      Order Summary
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => {
                        // Apply closing animation to summary content
                        const summaryContent =
                          document.querySelector(".summary-content");
                        if (summaryContent) {
                          summaryContent.style.animation =
                            "collapseSummary 0.15s ease";
                          // Wait briefly for animation to play before closing
                          setTimeout(() => setSummaryExpanded(false), 140);
                        } else {
                          setSummaryExpanded(false);
                        }
                      }}
                      style={{ padding: 4 }}
                    >
                      <ExpandMoreIcon />
                    </IconButton>
                  </Box>

                  <Divider style={{ marginBottom: 16 }} />

                  <Box
                    className="summary-content"
                    style={{
                      maxHeight: "60vh",
                      overflowY: "auto",
                      width: "100%",
                      animation: "$expandSummary 0.2s ease-out",
                    }}
                  >
                    {cart.map((item) => (
                      <Box key={item.id}>
                        {isBundleOffer || isAdsRegion ? (
                          <Box className={classes.summaryItem}>
                            <Box className={classes.summaryItemDetails}>
                              <Typography className={classes.summaryItemName}>
                                {item.title}
                              </Typography>
                            </Box>
                            <Typography className={classes.summaryItemPrice}>
                              {item.originalPrice &&
                                item.originalPrice > item.price && (
                                  <span className={classes.originalPrice}>
                                    {pageConfig.currencySymbol}
                                    {item.originalPrice}
                                  </span>
                                )}
                              {pageConfig.currencySymbol}
                              {item.price}
                            </Typography>
                          </Box>
                        ) : (
                          Array.isArray(item.items) &&
                          item.items.length > 0 && (
                            <Box>
                              {item.items.map((it, idx) => (
                                <Box
                                  key={idx}
                                  className={classes.summaryAddonItem}
                                >
                                  <Typography
                                    className={classes.summaryAddonName}
                                  >
                                    {it.title}
                                  </Typography>
                                  <Typography
                                    className={classes.summaryItemPrice}
                                  >
                                    {it.originalPrice &&
                                      it.originalPrice > it.price && (
                                        <span className={classes.originalPrice}>
                                          {pageConfig.currencySymbol}
                                          {it.originalPrice}
                                        </span>
                                      )}
                                    {pageConfig.currencySymbol}
                                    {it.price}
                                  </Typography>
                                </Box>
                              ))}
                            </Box>
                          )
                        )}
                      </Box>
                    ))}

                    {/* Show Add-ons section in mobile drawer if there are addons */}
                    {addons.filter((addon) => addon.selected).length > 0 && (
                      <>
                        {addons
                          .filter((addon) => addon.selected)
                          .map((addon) => (
                            <Box
                              key={addon.id}
                              className={classes.summaryAddonItem}
                            >
                              <Typography className={classes.summaryAddonName}>
                                {addon.title}
                              </Typography>
                              <Typography className={classes.summaryItemPrice}>
                                {pageConfig.currencySymbol}
                                {addon.price}
                              </Typography>
                            </Box>
                          ))}
                      </>
                    )}

                    <Divider style={{ margin: "10px 0" }} />

                    <Box className={classes.subtotalRow}>
                      <Typography variant="body2">Subtotal</Typography>
                      <Typography variant="body2">
                        {pageConfig.currencySymbol}
                        {getSubtotal()}
                      </Typography>
                    </Box>

                    {couponApplied && couponData && (
                      <Box
                        className={classes.subtotalRow}
                        style={{ color: "#04cf66" }}
                      >
                        <Typography
                          variant="body2"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          {/* <CheckCircleIcon style={{ fontSize: 14, marginRight: 4 }} /> */}
                          Discount{" "}
                          {couponData.discountType === "percentage"
                            ? `(${couponData.discountValue}%)`
                            : ""}
                        </Typography>
                        <Typography variant="body2">
                          -{pageConfig.currencySymbol}
                          {parseFloat(discount).toFixed(2)}
                        </Typography>
                      </Box>
                    )}

                    {/* GST Row for Mobile Drawer */}
                    {pageConfig.gstPercentage &&
                      pageConfig.gstPercentage > 0 && (
                        <Box className={classes.subtotalRow}>
                          <Typography variant="body2">
                            {pageConfig.gstLabel ||
                              `GST (${pageConfig.gstPercentage}%)`}
                          </Typography>
                          <Typography variant="body2">
                            {pageConfig.currencySymbol}
                            {getGstAmount().toFixed(2)}
                          </Typography>
                        </Box>
                      )}

                    {/* Coupon Section */}
                    {!pageConfig.hideCouponSection && (
                      <div className={classes.couponSection}>
                        <Typography
                          variant="subtitle2"
                          className={classes.couponLabel}
                        >
                          Got a coupon code?
                        </Typography>
                        <div className={classes.couponInput}>
                          <TextField
                            className={classes.couponTextField}
                            variant="outlined"
                            placeholder="Enter Code"
                            value={couponCode}
                            onChange={handleCouponChange}
                            fullWidth
                            size="small"
                            inputProps={{
                              style: { fontSize: "14px" },
                            }}
                          />
                          <Button
                            className={classes.couponButton}
                            onClick={handleApplyCoupon}
                            disabled={validatingCoupon || !couponCode.trim()}
                            size="small"
                          >
                            {validatingCoupon ? (
                              <CircularProgress size={16} color="inherit" />
                            ) : (
                              "Apply"
                            )}
                          </Button>
                        </div>
                        {couponApplied && (
                          <Typography
                            variant="body2"
                            className={classes.successText}
                          >
                            <CheckCircleIcon className={classes.successIcon} />
                            {couponMessage}
                          </Typography>
                        )}
                        {couponMessage && !couponApplied && (
                          <Typography
                            variant="body2"
                            className={classes.errorText}
                          >
                            {couponMessage}
                          </Typography>
                        )}
                      </div>
                    )}

                    <Box className={classes.totalRow}>
                      <Typography className={classes.totalLabel}>
                        Total{" "}
                        {pageConfig.gstPercentage &&
                        pageConfig.gstPercentage > 0
                          ? "(incl. GST)"
                          : ""}
                      </Typography>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-end"
                      >
                        <Box display="flex" alignItems="center">
                          {(() => {
                            // Calculate original total if items have original prices
                            let originalTotal = 0;
                            cart.forEach((item) => {
                              if (item.originalPrice) {
                                originalTotal += item.originalPrice;
                              }
                            });
                            addons.forEach((addon) => {
                              if (addon.selected && addon.originalPrice) {
                                originalTotal += addon.originalPrice;
                              }
                            });

                            // Add GST to original total if applicable
                            if (
                              pageConfig.gstPercentage &&
                              pageConfig.gstPercentage > 0 &&
                              originalTotal > 0
                            ) {
                              originalTotal =
                                originalTotal +
                                originalTotal *
                                  (pageConfig.gstPercentage / 100);
                            }

                            return originalTotal > getTotalAmount() ? (
                              <Typography
                                className={classes.originalPriceTotal}
                              >
                                {pageConfig.currencySymbol}
                                {parseFloat(originalTotal.toFixed(2))}
                              </Typography>
                            ) : null;
                          })()}
                          <Typography className={classes.totalAmount}>
                            {pageConfig.currencySymbol}
                            {getTotalAmount()}
                          </Typography>
                        </Box>
                        {getTotalUsdEquivalent() > 0 && (
                          <Typography className={classes.usdEquivalent}>
                            (≈ ${getTotalUsdEquivalent()})
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Drawer>
            )}

            <Box className={classes.stickyBottomBar}>
              <Box>
                <Typography className={classes.mobileTotal}>
                  Total: {pageConfig.currencySymbol}
                  {getTotalAmount()}{" "}
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#666",
                      marginLeft: "4px",
                    }}
                  >
                    {pageConfig.gstPercentage && pageConfig.gstPercentage > 0
                      ? "(incl. GST)"
                      : ""}
                  </span>
                  {getTotalUsdEquivalent() > 0 && (
                    <span
                      style={{
                        fontSize: "13px",
                        color: "#666",
                        marginLeft: "4px",
                      }}
                    >
                      (≈ ${getTotalUsdEquivalent()})
                    </span>
                  )}
                </Typography>
                <Typography
                  className={classes.mobileTotalAmount}
                  onClick={() => setSummaryExpanded(true)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    color: "#04cf66",
                    fontWeight: 500,
                  }}
                >
                  View plan summary
                  <ExpandLessIcon
                    style={{
                      fontSize: 16,
                      marginLeft: 4,
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Typography>
              </Box>
              <Button
                className={classes.mobileProceedButton}
                onClick={handleProceed}
                disabled={submitting}
              >
                {submitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  `Buy Now`
                )}
              </Button>
            </Box>
          </>
        )}
      </div>
    );
  };

  // Fix the renderMobileFooter function to use the correct loading state for step 0
  const renderMobileFooter = () => {
    // Skip rendering if already on step 1 since renderPlansStep will handle it
    if (activeStep === 1) return null;

    // Only render for step 0 when mobile and has items (though this shouldn't happen in practice)
    if (isMobile && activeStep === 0) {
      return (
        <Box className={classes.stickyBottomBar}>
          <Box className={classes.trustBadge}>
            <VerifiedUserIcon className={classes.trustIcon} />
            <Box>
              <Typography
                claxrssName={classes.trustHeading}
                style={{ marginBottom: "2px" }}
              >
                Trusted by <span className={classes.highlight}>210K+</span>{" "}
                businesses
              </Typography>
              <Typography className={classes.trustSubheading}>
                Across <span className={classes.highlight}>68</span> countries
              </Typography>
            </Box>
          </Box>
          <Button
            variant="contained"
            disableElevation
            className={classes.mobileProceedButton}
            onClick={handleProceed}
            disabled={formSubmitting}
          >
            {formSubmitting ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Continue"
            )}
          </Button>
        </Box>
      );
    }

    return null;
  };

  // alertSiteLeave = (e) => {
  //   if (submitting) {
  //     const confirmationMessage = "Payment will fail if you close this site!";
  //     e.preventDefault();
  //     e.returnValue = confirmationMessage;
  //     return confirmationMessage;
  //   }
  // };

  // Add the handleSubmit function to handle checkout in step 2
  const handleSubmit = async () => {
    setSubmitting(true);

    // Track payment initiation
    posthog.capture("plans_payment_initiated", {
      region: region,
      total_amount: getTotalAmount(),
      selected_plans: cart,
      billing_period: billingPeriod,
      user_email: formData.email,
    });

    try {
      // Prepare checkout data
      const selectedPlan = plans.find((plan) =>
        cart.some((item) => item.id === plan.id),
      );
      const selectedAddons = addons.filter((addon) => addon.selected);

      // Ensure a plan is selected if addons are present or if cart is empty
      if (!selectedPlan && selectedAddons.length > 0) {
        setError("Please select a base plan before adding add-ons.");
        setShowError(true);
        setSubmitting(false);
        return;
      }
      if (!selectedPlan && selectedAddons.length === 0) {
        setError("Please select a plan to proceed.");
        setShowError(true);
        setSubmitting(false);
        return;
      }

      const checkoutData = {
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        organizationName: formData.organizationName,
        organizationSize: formData.organizationSize,
        industry: formData.industry,
        currency: pageConfig.currency,
        plan: selectedPlan
          ? {
              id: selectedPlan.id,
              title: selectedPlan.title,
              price: selectedPlan.price,
              billingPeriod: selectedPlan.fixedBillingPeriod || billingPeriod,
            }
          : null,
        addons: selectedAddons.map((addon) => ({
          id: addon.id,
          title: addon.title,
          price: addon.price,
        })),
        region: region,
        version: version,
        coupon: couponApplied ? couponCode : null,
        totalAmount: getSubtotal() - discount, // Send the amount before GST
        currencySymbol: pageConfig.currencySymbol,
        source: "aisensy_regional_plans",
        countryCallingCode: selectedCountry.dial_code,
        isoCode: selectedCountry.code,
        couponCode: couponApplied ? couponCode : null,
        cancelUrl: `${CHECKOUT_PREFIX}${cancelPath}`,
        redirectUrl: `${CHECKOUT_PREFIX}/thankyou-${region}?${new URLSearchParams({ slug: `${region}-plans-${version}`, ...utmParams }).toString()}`,
        utmParams: utmParams,
        // Ties the conversion back to the page view that produced it.
        visitorId: getVisitorId(),
      };

      // Send checkout data to backend
      const { data } = await axios.post(
        `${INTEGRATION_SERVER_URL}/regionalplans/t1/create-intent-for-plans`,
        checkoutData,
      );

      if (data.success) {
        fireOnce("as_payment_initiated", {
          order_id: data.data.intentId,
          value: getTotalAmount(),
          currency: data.data.currency || "INR",
          plan: selectedPlan?.title,
          region,
          version,
        });
        const paymentGateway = data.data.paymentGateway;
        if (paymentGateway === "razorpay") {
          // Handle Razorpay Checkout
          const razorpayOptions = {
            key: data.data.keyId,
            amount: Math.round(getTotalAmount() * 100),
            currency: data.data.currency,
            name: "AISENSY COMMUNICATIONS PVT LTD",
            description:
              data.data.description ||
              `Payment for ${selectedPlan?.title || "services"}`,
            order_id: data.data.intentId,
            handler: function (response) {
              try {
                sessionStorage.setItem(
                  "as_purchase",
                  JSON.stringify({
                    transaction_id: response.razorpay_payment_id,
                    order_id: data.data.intentId,
                    value: getTotalAmount(),
                    currency: data.data.currency || "INR",
                    region,
                    version,
                    plan: selectedPlan?.title,
                  })
                );
              } catch (e) {}
              if (window.fbq) {
                window.fbq("track", "Purchase", {
                  value: getTotalAmount(),
                  currency: data.data.currency || "INR",
                });
              }
              window.location.href = `${CHECKOUT_PREFIX}/thankyou-${region}?${new URLSearchParams({ slug: `${region}-plans-${version}`, ...utmParams }).toString()}`;
            },
            retry: { enabled: true },
            remember_customer: true,
            modal: {
              backdropclose: false,
              escape: false,
              handleback: true,
              animation: true,
              confirm_close: true,
              ondismiss: () => {
                setSubmitting(false);
              },
            },
            prefill: {
              name: formData.fullName,
              email: formData.email,
              contact: `${selectedCountry.dial_code}${formData.phone}`,
            },
            notes: data.data.notes || {
              region: region,
              version: version,
              planId: selectedPlan?.id,
              source: "aisensy_regional_plans",
            },
            theme: {
              color: "#04CF66",
            },
          };

          const rzp = new window.Razorpay(razorpayOptions);
          rzp.on("payment.failed", function (response) {
            // console.error("Razorpay Payment Failed:", response.error);
            setError(
              `Payment Failed: ${response.error.description} (Reason: ${
                response.error.reason || "Unknown"
              })`,
            );
            setShowError(true);
            setSubmitting(false);
          });

          // window.addEventListener("beforeunload", alertSiteLeave());

          rzp.open();
          // setSubmitting(false) should not be here if rzp.open() is async or if we want to keep loading state until payment modal closes or fails
        } else if (data.data.status === "CREATED" && data.data.fwdUrl) {
          // Existing XPay logic
          window.location.href = data.data.fwdUrl;
        } else {
          throw new Error(
            data.message || "Checkout failed: Unexpected response from server.",
          );
        }
      } else {
        throw new Error(data.message || "Checkout failed to initiate.");
      }
    } catch (err) {
      // console.error("Checkout handleSubmit error:", err);
      setError(
        err.response?.data?.message ||
          err.message ||
          "There was an error processing your payment. Please try again.",
      );
      setShowError(true);
      setSubmitting(false);
    }
    // Do not setSubmitting(false) here if Razorpay is opened, as it handles its own state.
    // It should be set in Razorpay's failure handler or if the initial API call fails.
  };

  return (
    <div className={classes.root}>
      {activeStep === 0 && renderUserDetailsStep()}
      {activeStep === 1 && renderPlansStep()}
      {renderMobileFooter()}
      <Snackbar
        open={showError}
        autoHideDuration={4000}
        onClose={() => {
          setShowError(false);
          setError(null);
        }}
        message={error}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        ContentProps={{
          className: classes.errorSnackbar,
        }}
      />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(8),
    background: `linear-gradient(135deg, #f9fcfa 0%, #f5f5f5 100%)`,
    backgroundImage: `
      url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 0h2v20H9V0zm25.134.84l1.732 1-10 17.32-1.732-1 10-17.32zm-20 20l1.732 1-10 17.32-1.732-1 10-17.32zM58.16 4.134l1 1.732-17.32 10-1-1.732 17.32-10zm-40 40l1 1.732-17.32 10-1-1.732 17.32-10zM80 9v2H60V9h20zm20 69v2H0v-2h20zm79.32-55l-1 1.732-17.32-10L82 4l17.32 10zm-80 80l-1 1.732-17.32-10L2 84l17.32 10zm96.546-75.84l-1.732 1-10-17.32 1.732-1 10 17.32zm-100 100l-1.732 1-10-17.32 1.732-1 10 17.32zM38.16 24.134l1 1.732-17.32 10-1-1.732 17.32-10zM60 29v2H40v-2h20zm19.32 5l-1 1.732-17.32-10L62 24l17.32 10zm16.546 4.16l-1.732 1-10-17.32 1.732-1 10 17.32zM111 40h-2V20h2v20zm3.134.84l1.732 1-10 17.32-1.732-1 10-17.32zM40 49v2H20v-2h20zm19.32 5l-1 1.732-17.32-10L42 44l17.32 10zm16.546 4.16l-1.732 1-10-17.32 1.732-1 10 17.32zM91 60h-2V40h2v20zm3.134.84l1.732 1-10 17.32-1.732-1 10-17.32zm24.026 3.294l1 1.732-17.32 10-1-1.732 17.32-10zM39.32 74l-1 1.732-17.32-10L22 64l17.32 10zm16.546 4.16l-1.732 1-10-17.32 1.732-1 10 17.32zM71 80h-2V60h2v20zm3.134.84l1.732 1-10 17.32-1.732-1 10-17.32zm24.026 3.294l1 1.732-17.32 10-1-1.732 17.32-10zM120 89v2h-20v-2h20zm-84.134 9.16l-1.732 1-10-17.32 1.732-1 10 17.32zM51 100h-2V80h2v20zm3.134.84l1.732 1-10 17.32-1.732-1 10-17.32zm24.026 3.294l1 1.732-17.32 10-1-1.732 17.32-10zM100 109v2H80v-2h20zm19.32 5l-1 1.732-17.32-10 1-1.732 17.32 10zM31 120h-2v-20h2v20z' fill='%2304cf66' fill-opacity='0.02' fill-rule='evenodd'/%3E%3C/svg%3E"),
      radial-gradient(circle at 25% 10%, rgba(4, 207, 102, 0.05) 0%, rgba(4, 207, 102, 0) 20%),
      radial-gradient(circle at 75% 90%, rgba(4, 207, 102, 0.05) 0%, rgba(4, 207, 102, 0) 20%),
      linear-gradient(135deg, #f9fcfa 0%, #f5f5f5 100%)
    `,
    backgroundAttachment: "fixed",
    position: "relative",
    minHeight: "100vh",
    WebkitOverflowScrolling: "touch",
    overflowY: "auto",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "180px",
      background: `linear-gradient(180deg, rgba(4, 207, 102, 0.08) 0%, rgba(4, 207, 102, 0) 100%)`,
      zIndex: 0,
      pointerEvents: "none", // Prevent pseudo-element from blocking touch events
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3, 0.5),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(8),
      // Remove fixed background on mobile to fix scroll issues on Android
      backgroundAttachment: "scroll",
    },
  },
  container: {
    position: "relative",
    zIndex: 1,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 1),
    },
  },
  headerLogo: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(3),
      justifyContent: "center",
    },
  },
  logo: {
    height: 35,
    marginRight: theme.spacing(1),
  },
  partnerLogo: {
    height: 30,
    marginLeft: theme.spacing(1),
    opacity: 0.9,
  },
  partnerSeparator: {
    fontSize: "24px",
    fontWeight: 300,
    color: "#666",
    margin: theme.spacing(0, 1),
    display: "inline-flex",
    alignItems: "center",
  },
  partnershipBadge: {
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: "rgba(16, 185, 129, 0.1)",
    border: "1px solid rgba(16, 185, 129, 0.3)",
    borderRadius: "20px",
    padding: theme.spacing(0.5, 1.5),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      width: "100%",
    },
  },
  badgeText: {
    color: "#10B981",
    fontWeight: 600,
    fontSize: "12px",
    letterSpacing: "0.3px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
    },
  },
  pageTitle: {
    fontSize: "28px",
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    letterSpacing: "0.2px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      fontSize: "24px",
      marginBottom: theme.spacing(2),
    },
  },
  formTitle: {
    marginBottom: theme.spacing(3),
    fontSize: "18px",
    fontWeight: 600,
    position: "relative",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "-8px",
      left: "0",
      width: "40px",
      height: "3px",
      backgroundColor: "#04cf66",
    },
  },
  greenText: {
    color: "#04cf66",
  },
  featureBadges: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      marginBottom: theme.spacing(3),
    },
  },
  whatsappChip: {
    backgroundColor: "#E8F5E9",
    color: "#25D366",
    fontWeight: 500,
    border: "1px solid #C8E6C9",
    "& .MuiChip-icon": {
      color: "#25D366",
      height: "18px",
    },
    "&.MuiChip-root": {
      height: "22px",
    },
    [theme.breakpoints.down("sm")]: {
      "& .MuiChip-label": {
        padding: theme.spacing(0, 0.75),
        fontSize: "12px",
      },
    },
  },
  aiChip: {
    backgroundColor: "#E3F2FD",
    color: "#2196F3",
    fontWeight: 500,
    border: "1px solid #BBDEFB",
    "& .MuiChip-icon": {
      color: "#2196F3",
      height: "18px",
    },
    "&.MuiChip-root": {
      height: "22px",
    },
    [theme.breakpoints.down("sm")]: {
      "& .MuiChip-label": {
        padding: theme.spacing(0, 0.75),
        fontSize: "12px",
      },
    },
  },
  businessChip: {
    backgroundColor: "#FFF8E1",
    color: "#FF9800",
    fontWeight: 500,
    border: "1px solid #FFE0B2",
    "& .MuiChip-icon": {
      color: "#FF9800",
      height: "18px",
    },
    "&.MuiChip-root": {
      height: "22px",
    },
    [theme.breakpoints.down("sm")]: {
      "& .MuiChip-label": {
        padding: theme.spacing(0, 0.75),
        fontSize: "12px",
      },
    },
  },
  customIcon: {
    color: "inherit",
    verticalAlign: "middle",
    height: "24px",
    // marginRight: theme.spacing(1),
  },
  stickyBottomBar: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1.5),
    backgroundColor: "#ffffff",
    boxShadow: "0 -4px 12px rgba(0,0,0,0.1)",
    zIndex: 9999,
    height: theme.spacing(6),
    backgroundImage: `linear-gradient(to right, rgba(4, 207, 102, 0.05), rgba(255, 255, 255, 0.1))`,
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "2px",
      background: "linear-gradient(to right, #04cf66, rgba(4, 207, 102, 0.3))",
    },
    animation: "$slideInFromBottom 0.25s ease",
  },
  mobileTotal: {
    fontWeight: 600,
    fontSize: "16px",
  },
  mobileTotalAmount: {
    fontSize: "14px",
    color: "#666",
    marginTop: theme.spacing(0.5),
  },
  mobileProceedButton: {
    backgroundColor: "#04cf66 !important",
    color: "#ffffff !important",
    "&:hover": {
      backgroundColor: "#03b85a !important",
      color: "#ffffff !important",
    },
    "&:focus, &:focus-visible, &:active": {
      backgroundColor: "#03b85a !important",
      color: "#ffffff !important",
      outline: "none",
    },
    fontWeight: 600,
    textTransform: "none",
    "&.Mui-disabled": {
      backgroundColor: "#9adfbe !important",
      color: "#ffffff !important",
      opacity: 1,
    },
    padding: "10px 24px",
    borderRadius: "8px",
    transition: "background-color 0.15s ease, transform 0.15s ease",
    boxShadow: "0 2px 8px rgba(4, 207, 102, 0.3)",
    "&:active": {
      transform: "scale(0.98)",
    },
    width: "auto",
    minWidth: "120px",
  },
  mobileButtonText: {
    fontWeight: 500,
    color: "#333",
    fontSize: "14px",
  },
  "@keyframes slideInFromBottom": {
    "0%": {
      transform: "translateY(30%)",
      opacity: 0.5,
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
  mobileFormContainer: {
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  // Pulsing animations removed for a more streamlined appearance
  planCard: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
    borderRadius: "8px",
    marginBottom: theme.spacing(1.5),
    backgroundColor: "#ffffff",
    border: "1px solid rgba(234, 234, 234, 0.8)",
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    // "&:hover": {
    //   transform: "translateY(-2px)",
    //   boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    // },
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "5px",
      height: "100%",
      background: "#04cf66",
      borderTopLeftRadius: "8px",
      borderBottomLeftRadius: "8px",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
    },
  },
  tightPlanCard: {
    marginBottom: 0,
    paddingTop: theme.spacing(1.25),
    paddingBottom: theme.spacing(1.25),
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0,
      paddingTop: theme.spacing(1.25),
      paddingBottom: theme.spacing(1.25),
    },
  },
  selectedPlan: {
    border: "2px solid #04cf66",
    boxShadow: "0 2px 10px rgba(4, 207, 102, 0.15)",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "5px",
      height: "100%",
      background: "linear-gradient(to bottom, #04cf66, #04cf66aa)",
      borderTopLeftRadius: "8px",
      borderBottomLeftRadius: "8px",
    },
  },
  popularBadge: {
    position: "absolute",
    top: "10px",
    right: "-30px",
    backgroundColor: "#4A90E2", // Changed from orange to blue
    color: "white",
    padding: "4px 30px",
    transform: "rotate(45deg)",
    fontSize: "12px",
    fontWeight: "bold",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    zIndex: 1,
  },
  planTitle: {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: "#333",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  planSubtitle: {
    color: "#555",
    lineHeight: 1.4,
    fontSize: "15px",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  planHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  // High-conversion outcome pill rendered on ads cards directly under the
  // title — surfaces the projected quality-lead range so the visitor reads
  // VALUE before they read price. display: flex (not inline-flex) keeps it
  // a clean block-level row so margin top/bottom behave predictably
  // against the title above and the subtitle below.
  leadsHighlight: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginTop: theme.spacing(1.25),
    marginBottom: theme.spacing(1),
    padding: "5px 12px",
    borderRadius: 999,
    backgroundColor: "rgba(4, 207, 102, 0.10)",
    border: "1px solid rgba(4, 207, 102, 0.30)",
    width: "fit-content",
    maxWidth: "100%",
  },
  leadsHighlightIcon: {
    color: "#04cf66",
    fontSize: 16,
  },
  leadsHighlightText: {
    color: "#0d3b25",
    fontWeight: 600,
    fontSize: 13,
    letterSpacing: 0.2,
    lineHeight: 1.2,
  },
  // Transparent value-math panel on ads cards. Mirrors the festive landing
  // page's "Ad Credits Breakdown" — soft green tint, structured rows,
  // total bolded, daily-budget caption underneath. Replaces the prose
  // subtitle so the visitor sees how their rupees become credits and how
  // many days that funds, without parsing a sentence.
  adsBreakdown: {
    margin: theme.spacing(0.5, 0, 1.5, 0),
    padding: "12px 14px",
    borderRadius: 10,
    backgroundColor: "rgba(4, 207, 102, 0.06)",
    border: "1px solid rgba(4, 207, 102, 0.20)",
  },
  adsBreakdownTitle: {
    color: "#04a14f",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 0.2,
    marginBottom: 8,
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  adsBreakdownRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    padding: "3px 0",
  },
  adsBreakdownLabel: {
    color: "#4d5a52",
    fontSize: 13,
    fontWeight: 500,
  },
  adsBreakdownValue: {
    color: "#0d3b25",
    fontSize: 13,
    fontWeight: 600,
  },
  adsBreakdownExtra: {
    color: "#04a14f",
    fontSize: 13,
    fontWeight: 700,
  },
  adsBreakdownDivider: {
    height: 1,
    backgroundColor: "rgba(4, 207, 102, 0.20)",
    margin: "6px 0",
  },
  adsBreakdownTotalLabel: {
    color: "#0d3b25",
    fontSize: 14,
    fontWeight: 700,
  },
  adsBreakdownTotalValue: {
    color: "#04a14f",
    fontSize: 16,
    fontWeight: 800,
  },
  adsBreakdownCaption: {
    color: "#5f6c63",
    fontSize: 12,
    fontWeight: 500,
    marginTop: 6,
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  // Trust tagline directly under "Choose your Ad Credits Plan" — visitors
  // landing from a paid ad need a quick credibility cue before they
  // evaluate price, so a single concise line ("Easy to use platform •
  // Trusted by 210,000+ Businesses") sits between the heading and the
  // first pack card.
  adsTrustTagline: {
    color: "#5f6c63",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.4,
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    // Match the page heading: left-aligned on desktop, centered on mobile
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  adsTrustTaglineDot: {
    color: "#04cf66",
    fontWeight: 700,
    margin: "0 8px",
  },
  featureList: {
    padding: 0,
    marginBottom: theme.spacing(1),
  },
  featureItem: {
    padding: theme.spacing(0.5, 0),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  featureIcon: {
    minWidth: "16px",
    color: "#04cf66",
    marginRight: theme.spacing(0.5),
  },
  featureBullet: {
    fontSize: "8px",
    color: "#04cf66",
  },
  featureText: {
    fontSize: "13px",
    lineHeight: 1.4,
    color: "#444",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    margin: 0,
    "& .MuiTypography-root": {
      fontSize: "13px",
      lineHeight: 1.4,
    },
  },
  passActions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  spotsLeft: {
    fontSize: "15px",
    color: "#FF9800",
    fontWeight: 500,
    marginLeft: theme.spacing(1),
    display: "inline-flex",
    alignItems: "center",
  },
  planPriceBottom: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#04cf66",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  originalPrice: {
    textDecoration: "line-through",
    color: "#999",
    marginRight: theme.spacing(1),
    fontWeight: 500,
  },
  selectButton: {
    backgroundColor: "#04cf66",
    color: "#fff",
    padding: "10px 20px",
    borderRadius: "4px",
    fontWeight: 600,
    textTransform: "none",
    fontSize: "15px",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
  },
  selectedButton: {
    backgroundColor: "#E8F5E9",
    color: "#04cf66",
    padding: "10px 20px",
    borderRadius: "4px",
    fontWeight: 600,
    textTransform: "none",
    fontSize: "15px",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    border: "1px solid #04cf66",
    "&:hover": {
      backgroundColor: "#E8F5E9",
    },
  },
  addonSection: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  addonTitle: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    position: "relative",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "-8px",
      left: "0",
      width: "40px",
      height: "3px",
      backgroundColor: "#04cf66",
    },
  },
  addonCard: {
    padding: theme.spacing(1.4),
    borderRadius: "8px",
    border: "1px solid #eaeaea",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "all 0.2s ease",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f8f8f8",
      borderColor: "#d0d0d0",
      transform: "translateY(-1px)",
    },
  },
  addonSelected: {
    borderColor: "#04cf66",
    backgroundColor: "#f0f9f1",
    "&:hover": {
      backgroundColor: "#e8f5ed",
      borderColor: "#04cf66",
    },
  },
  addonContent: {
    display: "flex",
    alignItems: "flex-start",
    flexGrow: 1,
  },
  addonInfo: {
    marginLeft: theme.spacing(1),
  },
  addonName: {
    fontSize: "15px",
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
    color: "#333",
  },
  addonDescription: {
    fontSize: "13px",
    color: "#666",
    lineHeight: 1.3,
  },
  addonPrice: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#04cf66",
    marginLeft: theme.spacing(2),
  },
  addonCheckbox: {
    color: "#04cf66",
    padding: "0 8px 0 0",
  },
  proceedButton: {
    padding: theme.spacing(1.5),
    backgroundColor: "#04cf66",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
    borderRadius: "4px",
    fontWeight: 500,
    fontSize: "16px",
    textTransform: "none",
    marginTop: theme.spacing(1),
    height: "48px",
  },
  // Add checkout step styles
  summaryCard: {
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    backgroundColor: "#ffffff",
    position: "sticky",
    top: "20px",
    border: "1px solid #eaeaea",
    transition: "box-shadow 0.2s",
    overflow: "hidden",
    // "&:hover": {
    //   boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    // },
    "&:after": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      width: "100%",
      height: "5px",
      background: "linear-gradient(to right, #04cf66, #04cf66aa)",
    },
  },
  summaryTitle: {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    borderBottom: "2px solid #04cf66",
    paddingBottom: theme.spacing(0.5),
    display: "inline-block",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    letterSpacing: "0.2px",
  },
  summaryItem: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
    alignItems: "center",
  },
  summaryItemName: {
    flexGrow: 1,
    fontSize: "15px",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    fontWeight: 500,
    color: "#333",
  },
  summaryItemPrice: {
    fontWeight: 600,
    textAlign: "right",
    fontSize: "15px",
    color: "#222",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  subtotalRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "14px",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    color: "#666",
  },
  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(1),
    // marginBottom: theme.spacing(1.5),
    backgroundColor: "rgba(4, 207, 102, 0.05)",
    padding: theme.spacing(1),
    borderRadius: "6px",
  },
  totalLabel: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#222",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  totalAmount: {
    fontSize: "17px",
    fontWeight: 700,
    color: "#04cf66",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  usdEquivalent: {
    fontSize: "13px",
    color: "#666",
    marginLeft: theme.spacing(1),
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  couponSection: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    border: "1px solid #eaeaea",
  },
  couponLabel: {
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    fontSize: "14px",
    color: "#333",
  },
  couponInput: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  couponTextField: {
    flexGrow: 1,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
    },
  },
  couponButton: {
    minWidth: "100px",
    height: "40px",
    borderColor: "#04cf66",
    color: "#04cf66",
    "&:hover": {
      borderColor: "#03b85a",
      backgroundColor: "rgba(4, 207, 102, 0.04)",
    },
    "&.Mui-disabled": {
      borderColor: "#e0e0e0",
      color: "#9e9e9e",
    },
  },
  successText: {
    color: "#04cf66",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(0.5),
    fontSize: "13px",
  },
  successIcon: {
    marginRight: theme.spacing(0.5),
    fontSize: "14px",
    color: "#04cf66",
  },
  errorText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(0.5),
    fontSize: "13px",
  },
  billingDetailsTitle: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    position: "relative",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "-8px",
      left: "0",
      width: "40px",
      height: "3px",
      backgroundColor: "#04cf66",
    },
  },
  billingDetailsSection: {
    margin: theme.spacing(3, 0),
  },
  billingInfo: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
  },
  billingInfoItem: {
    display: "flex",
    marginBottom: theme.spacing(0.5),
    fontSize: "14px",
  },
  billingInfoLabel: {
    fontWeight: 600,
    minWidth: "120px",
  },
  billingInfoValue: {
    color: "#444",
  },
  // Add missing form styles
  formField: {
    marginBottom: theme.spacing(1.5),
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px",
    },
    "& .MuiInputLabel-root": {
      fontWeight: 500,
    },
    "& .MuiOutlinedInput-input": {
      padding: "15px 14px",
      [theme.breakpoints.up("md")]: {
        padding: "12px 14px",
      },
    },
    "&.MuiTextField-root": {
      padding: "0px 4px",
      backgroundColor: "#FFFFFF",
      borderRadius: "4px",
      border: "0.5px solid #e0e0e0",
    },
    [theme.breakpoints.up("md")]: {
      marginBottom: "12px",
    },
  },
  formFieldLabel: {
    marginBottom: "6px",
    fontWeight: 500,
    fontSize: "14px",
    color: "#333",
    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(0.5),
      fontSize: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
  phoneInputContainer: {
    display: "flex",
    alignItems: "center",
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "4px",
      },
    },
    "& .MuiOutlinedInput-adornedStart": {
      paddingLeft: "0px",
    },
    "& .MuiOutlinedInput-input": {
      paddingLeft: "8px",
    },
  },
  countryCodeInput: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#f9f9f9",
    borderRadius: "4px 0 0 4px",
    padding: "0 4px",
    height: "100%",
    borderRight: "1px solid #e0e0e0",
    "&:hover": {
      backgroundColor: "#f0f9f1",
    },
  },
  mobileMenuPaper: {
    maxHeight: "40vh",
    "& .MuiMenuItem-root": {
      minHeight: "40px",
      padding: "4px 16px",
    },
    "& .MuiListItem-root": {
      minHeight: "40px",
      padding: "4px 16px",
      paddingTop: "12px",
    },
    "& .MuiList-root": {
      paddingTop: "0px",
    },
  },
  industryMenuPaper: {
    maxHeight: "35vh",
    width: "90%",
    margin: "0 auto",
    borderRadius: "8px",
    "& .MuiMenuItem-root": {
      minHeight: "36px",
      fontSize: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: "45vh",
    },
  },
  autocompleteInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px",
      border: "0.5px solid #e0e0e0",
    },
    "& .MuiAutocomplete-inputRoot": {
      padding: "0px !important",
    },
    "& .MuiAutocomplete-input": {
      padding: "12px 14px !important",
    },
    "& .MuiAutocomplete-popper": {
      maxHeight: "35vh",
    },
    "& .MuiTextField-root": {
      backgroundColor: "#FFFFFF",
      padding: "0px",
    },
  },
  helperText: {
    fontSize: "12px",
    marginLeft: "14px",
    marginTop: "4px",
  },
  errorSnackbar: {
    backgroundColor: "#ffebee",
    color: "#d32f2f",
  },
  // Urgency elements removed
  // Social proof container removed for cleaner interface
  // Stepper styles - more compact
  stepper: {
    backgroundColor: "transparent",
    padding: 0,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
    },
  },
  stepLabel: {
    "& .MuiStepLabel-label": {
      fontSize: "14px",
      fontWeight: 500,
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px",
      },
    },
    "& .MuiStepLabel-active": {
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
    "& .MuiStepLabel-completed": {
      color: "#04cf66",
      fontWeight: 600,
    },
  },
  stepContent: {
    borderLeft: "1px dashed rgba(4, 207, 102, 0.4)",
    marginLeft: theme.spacing(2.1),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1.6),
      paddingLeft: theme.spacing(1.5),
    },
  },
  stepDescription: {
    display: "none", // Hide step descriptions for compactness
  },
  customStepIcon: {
    backgroundColor: "#04cf66",
    color: "white",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "12px",
  },
  inactiveStepIcon: {
    backgroundColor: "#eaeaea",
    color: "#999",
  },
  formContainer: {
    padding: theme.spacing(3),
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    background: "#ffffff",
    backgroundImage: `radial-gradient(circle at 90% 10%, rgba(4, 207, 102, 0.03) 0%, rgba(255, 255, 255, 0) 70%)`,
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  formHeader: {
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: "1px solid rgba(0,0,0,0.05)",
  },
  formInputLabel: {
    marginBottom: "5.5px",
    fontWeight: 500,
    fontSize: "14px",
    color: "#333",
  },
  formInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#e0e0e0",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#04cf66",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#04cf66",
      },
    },
    "& .MuiInputBase-input": {
      padding: "12px 14px",
      fontSize: "14px",
    },
  },
  formInputIcon: {
    color: "#666",
    fontSize: "20px",
  },
  radioGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(2),
    },
  },
  radioButton: {
    flex: "0 0 calc(50% - 5px)",
    margin: 0,
    [theme.breakpoints.down("xs")]: {
      flex: "0 0 100%",
    },
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "92%",
    padding: "8px 12px",
    border: "0.5px solid #e0e0e0",
    borderRadius: "4px",
    transition: "all 0.2s ease",
    cursor: "pointer",
    backgroundColor: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#f9f9f9",
      borderColor: "#cccccc",
    },
  },
  radioLabelSelected: {
    backgroundColor: "#f0f9f1",
    borderColor: "#04cf66",
    "& .MuiFormControlLabel-label": {
      fontWeight: 500,
    },
  },
  radioRoot: {
    padding: "0",
    marginRight: "8px",
    color: "#04cf66",
  },
  radioErrorText: {
    color: "#f44336",
    fontSize: "12px",
    marginTop: "4px",
    marginLeft: "14px",
  },
  proceedButton: {
    padding: theme.spacing(1.5),
    backgroundColor: "#04cf66",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
    borderRadius: "4px",
    fontWeight: 500,
    fontSize: "16px",
    textTransform: "none",
    marginTop: theme.spacing(1),
    height: "48px",
  },
  mobileFullWidth: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  billingToggle: {
    marginBottom: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
    },
  },
  toggleContainer: {
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      "& .MuiToggleButtonGroup-root": {
        width: "100%",
      },
      "& .MuiToggleButton-root": {
        flex: 1,
        padding: theme.spacing(0.75, 1),
      },
    },
  },
  toggleButton: {
    "&.MuiToggleButton-root": {
      borderColor: "#e0e0e0",
      color: "#666",
      padding: theme.spacing(0.75, 2),
      "&.Mui-selected": {
        backgroundColor: "rgba(4, 207, 102, 0.08)",
        color: "#04cf66",
        borderColor: "#04cf66",
        fontWeight: 600,
      },
      "&:hover": {
        backgroundColor: "rgba(4, 207, 102, 0.05)",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    },
  },
  savingBadge: {
    backgroundColor: "#E8F5E9", // Changed from blue to light green
    color: "#04cf66", // Changed to green
    padding: theme.spacing(0.2, 0.5),
    borderRadius: "20px",
    fontSize: "10px",
    fontWeight: 600,
    marginLeft: theme.spacing(0.5),
    display: "inline-flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "9px",
      padding: theme.spacing(0.1, 0.3),
    },
  },
  planStructure: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(1),
    },
  },
  planContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  spacer: {
    flexGrow: 1,
    minHeight: theme.spacing(2),
  },
  highlightedFeature: {
    backgroundColor: "rgba(4, 207, 102, 0.08)",
    padding: theme.spacing(0.4, 1),
    borderRadius: "4px",
    display: "inline-flex",
    alignItems: "center",
    fontSize: "13px",
    color: "#038f48",
    fontWeight: 500,
    marginTop: theme.spacing(1),
  },
  highlightIcon: {
    fontSize: "14px",
    marginRight: theme.spacing(0.5),
    color: "#04cf66",
  },
  billingLabel: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1.5),
    fontWeight: 500,
  },
  billingIcon: {
    color: "#04cf66",
    marginRight: theme.spacing(1),
    fontSize: "20px",
  },
  stepperContainer: {
    padding: theme.spacing(2),
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
  },
  trustSignals: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: "4px",
    backgroundColor: "#f9f9f9",
    textAlign: "center",
  },
  trustText: {
    fontSize: "12px",
    color: "#666",
  },
  lockIcon: {
    marginRight: theme.spacing(0.5),
    fontSize: "14px",
    color: "#666",
  },
  reliableChip: {
    backgroundColor: "#FFF8E1",
    color: "#FF9800",
    fontWeight: 500,
    border: "1px solid #FFE0B2",
    "& .MuiChip-icon": {
      color: "#FF9800",
    },
  },
  formGrid: {
    display: "flex",
    flexWrap: "wrap",
    margin: theme.spacing(0, -1),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  formGridItem: {
    flex: "1 1 calc(50% - 16px)",
    margin: theme.spacing(0, 1, 1.5),
    [theme.breakpoints.down("xs")]: {
      flex: "1 1 100%",
    },
  },
  stepper: {
    backgroundColor: "transparent",
    padding: theme.spacing(1),
    "& .MuiStepIcon-root": {
      color: "#f0f0f0",
      "&.MuiStepIcon-active": {
        color: "#04cf66",
      },
      "&.MuiStepIcon-completed": {
        color: "#04cf66",
      },
    },
  },
  stepLabel: {
    "& .MuiStepLabel-label": {
      fontSize: "14px",
      fontWeight: 500,
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px",
      },
    },
    "& .MuiStepLabel-active": {
      fontWeight: 600,
      color: "#04cf66",
    },
    "& .MuiStepLabel-completed": {
      color: "#04cf66",
      fontWeight: 600,
    },
  },
  sideContentPaper: {
    padding: theme.spacing(3),
    borderRadius: "8px",
    backgroundColor: "transparent",
    paddingLeft: "0px",
    paddingTop: "73px",
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingLeft: "0px",
      paddingRight: "0px",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(3),
    },
  },
  sideContentTitle: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: "18px",
    color: "#222",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      marginBottom: theme.spacing(1.5),
    },
  },
  benefitItem: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(0.5, 0),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  benefitIcon: {
    marginRight: theme.spacing(1),
    fontSize: "16px",
    color: "rgba(4, 207, 102, 0.85)",
    marginTop: "2px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  benefitTitle: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#222",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    lineHeight: 1.4,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  benefitDesc: {
    fontSize: "12px",
    color: "#555",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    lineHeight: 1.4,
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      lineHeight: 1.3,
    },
  },
  testimonial: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: "8px",
    backgroundColor: "rgba(252, 252, 252, 0.4)",
    border: "1px solid rgba(234, 234, 234, 0.5)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.01)",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(1.5),
    },
  },
  testimonialText: {
    fontSize: "14px",
    color: "#555",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  testimonialAuthor: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  testimonialAvatar: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    marginRight: theme.spacing(1),
  },
  billingToggleContainer: {
    marginBottom: theme.spacing(3),
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
    },
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    position: "relative",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "-8px",
      left: "0",
      width: "40px",
      height: "3px",
      backgroundColor: "#04cf66",
    },
  },
  planActions: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-end",
  },
  addToCartButton: {
    backgroundColor: "#04cf66",
    color: "#fff",
    padding: theme.spacing(1, 2),
    borderRadius: "4px",
    fontWeight: 600,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
  },
  accordionContainer: {
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(0),
    borderRadius: "4px",
    backgroundColor: "transparent",
    border: "none",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
  seeMoreButton: {
    fontSize: "13px",
    color: "#04cf66",
    fontWeight: 500,
    textTransform: "none",
    padding: theme.spacing(0.5, 1),
    backgroundColor: "rgba(4, 207, 102, 0.06)",
    borderRadius: "4px",
    margin: theme.spacing(0.5, 0),
    width: "100%",
    justifyContent: "center",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(4, 207, 102, 0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      padding: theme.spacing(0.3, 1),
    },
  },
  accordionExpanded: {
    backgroundColor: "rgba(4, 207, 102, 0.02)",
    borderRadius: "4px",
    padding: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    borderLeft: "2px solid rgba(4, 207, 102, 0.2)",
  },
  featureCheck: {
    color: "#04cf66",
    fontSize: "16px",
  },
  expanded: {
    maxHeight: "500px",
    opacity: 1,
    transition: "max-height 0.3s ease-in-out, opacity 0.2s ease-in-out",
  },
  extraFeatures: {
    overflow: "hidden",
    maxHeight: "0",
    transition: "max-height 0.3s ease-in-out, opacity 0.2s ease-in-out",
    backgroundColor: "rgba(4, 207, 102, 0.03)",
    borderRadius: "4px",
    margin: theme.spacing(0.5, 0),
    opacity: 0,
  },
  emptyCartContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    backgroundColor: "rgba(4, 207, 102, 0.03)",
    borderRadius: "10px",
    border: "1px dashed rgba(4, 207, 102, 0.3)",
  },
  emptyCartIcon: {
    fontSize: "54px",
    color: "rgba(4, 207, 102, 0.7)",
    marginBottom: theme.spacing(2),
  },
  emptyCartText: {
    color: "#444",
    textAlign: "center",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  emptyCartHighlight: {
    color: "#04cf66",
    fontWeight: 600,
  },
  emptyCartSubtext: {
    color: "#666",
    fontSize: "14px",
    textAlign: "center",
    maxWidth: "90%",
    lineHeight: 1.5,
  },
  summaryCard: {
    borderRadius: "10px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    backgroundColor: "#ffffff",
    position: "sticky",
    top: "20px",
    border: "1px solid #eaeaea",
    transition: "box-shadow 0.2s",
    overflow: "hidden",
    // "&:hover": {
    //   boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    // },
    "&:after": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      width: "100%",
      height: "4px",
      background: "linear-gradient(to right, #04cf66, #04cf66aa)",
    },
  },
  summaryTitle: {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    borderBottom: "2px solid #04cf66",
    paddingBottom: theme.spacing(0.5),
    display: "inline-block",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    letterSpacing: "0.2px",
  },
  summaryItem: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
    alignItems: "center",
  },
  summaryItemName: {
    flexGrow: 0.8,
    fontSize: "15px",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    fontWeight: 500,
    color: "#333",
  },
  summaryItemQty: {
    marginRight: theme.spacing(1),
    color: "#555",
    width: "24px",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: 500,
  },
  summaryItemPrice: {
    fontWeight: 600,
    textAlign: "right",
    fontSize: "15px",
    color: "#222",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  summaryAddonItem: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(0.75),
    // padding: theme.spacing(0.5, 1),
    // backgroundColor: "#f9f9f9",
    borderRadius: "4px",
    alignItems: "center",
  },
  summaryAddonName: {
    fontSize: "15px",
    fontWeight: 500,
    color: "#444",
  },
  addonLabel: {
    display: "flex",
    flexDirection: "column",
  },
  addonLabelText: {
    fontSize: "14px",
    fontWeight: 500,
  },
  addonLabelDesc: {
    fontSize: "12px",
    color: "#666",
  },
  couponSection: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  couponLabel: {
    marginBottom: theme.spacing(0.5),
    fontWeight: 600,
    fontSize: "14px",
    color: "#222",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  couponInput: {
    display: "flex",
    alignItems: "center",
  },
  couponTextField: {
    flexGrow: 1,
    marginRight: theme.spacing(1),
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 12px",
    },
    "&.MuiTextField-root": {
      padding: "0px",
    },
  },
  couponButton: {
    height: "36px",
    padding: "0 12px",
    backgroundColor: "#ffffff",
    color: "#04cf66",
    border: "1px solid #04cf66",
    borderRadius: "4px",
    fontWeight: 500,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#f0f9f1",
    },
    "&.Mui-disabled": {
      backgroundColor: "#f0f9f1",
      color: "#83d9b2",
      border: "1px solid #c8f0db",
      opacity: 0.8,
    },
  },
  successText: {
    color: "#04cf66",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(0.5),
    fontSize: "13px",
  },
  successIcon: {
    marginRight: theme.spacing(0.5),
    fontSize: "14px",
    color: "#04cf66",
  },
  errorText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(0.5),
    fontSize: "13px",
  },
  proceedButton: {
    padding: theme.spacing(1.25, 0),
    backgroundColor: "#04cf66",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
    marginTop: theme.spacing(1.5),
    borderRadius: "4px",
    fontWeight: 500,
    fontSize: "15px",
    textTransform: "none",
    "&.Mui-disabled": {
      backgroundColor: "#bbbbbb",
      color: "#ffffff",
    },
  },
  backButton: {
    padding: theme.spacing(1, 2),
    backgroundColor: "#f5f5f5",
    color: "#000000",
    borderRadius: "4px",
    fontWeight: 500,
    fontSize: "14px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  },
  testimonialCard: {
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: "relative",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    "& .MuiAvatar-root": {
      width: 36,
      height: 36,
      border: "2px solid #fff",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
  },
  testimonialQuote: {
    fontStyle: "italic",
    fontSize: "14px",
    color: "#555",
    margin: theme.spacing(1, 0),
    paddingLeft: theme.spacing(1),
    borderLeft: "2px solid rgba(4, 207, 102, 0.3)",
  },
  testimonialAuthor: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  testimonialName: {
    marginLeft: theme.spacing(1),
    fontSize: "13px",
    fontWeight: 600,
  },
  testimonialCompany: {
    fontSize: "12px",
    color: "#757575",
  },
  "@keyframes pulseGreen": {
    "0%": {
      transform: "scale(0.95)",
      boxShadow: "0 0 0 0 rgba(4, 207, 102, 0.7)",
    },
    "70%": {
      transform: "scale(1)",
      boxShadow: "0 0 0 8px rgba(4, 207, 102, 0)",
    },
    "100%": {
      transform: "scale(0.95)",
      boxShadow: "0 0 0 0 rgba(4, 207, 102, 0)",
    },
  },
  "@keyframes slideInFromBottom": {
    "0%": {
      transform: "translateY(30%)",
      opacity: 0.5,
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
  "@keyframes expandSummary": {
    "0%": {
      maxHeight: "0",
      opacity: 0.5,
      transform: "translateY(5px)",
    },
    "100%": {
      maxHeight: "60vh",
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  "@keyframes collapseSummary": {
    "0%": {
      maxHeight: "60vh",
      opacity: 1,
      transform: "translateY(0)",
    },
    "100%": {
      maxHeight: "0",
      opacity: 0.5,
      transform: "translateY(5px)",
    },
  },
  billingToggleContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    display: "flex",
    justifyContent: "flex-start",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      marginBottom: theme.spacing(3),
    },
  },
  toggleContainer: {
    backgroundColor: "#f0f2f5",
    borderRadius: "12px",
    padding: "4px",
    display: "inline-flex",
    border: "1px solid #e0e4e8",
    position: "relative",
    zIndex: 0,
    "&.MuiToggleButtonGroup-root": {
      border: "none",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      top: "4px",
      left: "4px",
      height: "calc(100% - 8px)",
      width: "calc((100% - 8px) / var(--total-items))",
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      transform: "translateX(calc(var(--active-index) * 100%))",
      transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      zIndex: -1,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "360px",
      borderRadius: "10px",
    },
  },
  toggleButton: {
    "&.MuiToggleButton-root": {
      border: "none !important",
      color: "#667085",
      padding: theme.spacing(1, 3),
      textTransform: "none",
      fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 500,
      fontSize: "14px",
      borderRadius: "8px !important",
      transition: "color 0.2s ease",
      minWidth: "120px",
      minHeight: "40px",
      backgroundColor: "transparent !important",
      position: "relative",
      zIndex: 1,
      "&.Mui-selected": {
        color: "#04cf66 !important",
        fontWeight: 600,
        backgroundColor: "transparent !important",
        "&:hover": {
          backgroundColor: "transparent !important",
        },
      },
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.02) !important",
        color: "#04cf66",
      },
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(0.75, 1.5),
        fontSize: "13px",
        flex: 1,
        minWidth: "auto",
      },
    },
  },
  mobileDrawerPaper: {
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    maxHeight: "80vh",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: "50px",
      height: "4px",
      backgroundColor: "#e0e0e0",
      borderRadius: "4px",
      margin: "8px 0",
    },
  },
  mobileDrawerContent: {
    maxHeight: "75vh",
    overflowY: "auto",
    padding: theme.spacing(1, 2, 4),
  },
  selectButton: {
    backgroundColor: "#04cf66",
    color: "#fff",
    padding: "10px 18px",
    borderRadius: "4px",
    fontWeight: 600,
    textTransform: "none",
    fontSize: "14px",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
  },
  selectedButton: {
    backgroundColor: "#E8F5E9",
    color: "#04cf66",
    padding: "10px 18px",
    borderRadius: "4px",
    fontWeight: 600,
    textTransform: "none",
    fontSize: "14px",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    border: "1px solid #04cf66",
    "&:hover": {
      backgroundColor: "#E8F5E9",
    },
  },
  spotsLeft: {
    fontSize: "12px",
    color: "#FF9800",
    fontWeight: 500,
    marginLeft: theme.spacing(0.5),
    display: "inline-flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
      padding: theme.spacing(0.1, 0.3),
    },
  },
  planSubtitle: {
    color: "#555",
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.4,
    fontSize: "14px",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      marginBottom: theme.spacing(1),
    },
  },
  planPriceBottom: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#04cf66",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
  },
  warningIcon: {
    fontSize: "14px",
    marginRight: theme.spacing(0.5),
    color: "#FF9800",
  },
  addonTooltip: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    color: "#ffffff",
    fontSize: "13px",
    padding: theme.spacing(1, 1.5),
    borderRadius: "4px",
    fontWeight: 500,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    maxWidth: "220px",
    zIndex: 9999,
    "& .MuiTooltip-arrow": {
      color: "rgba(0, 0, 0, 0.8)",
    },
  },
  featureCheck: {
    color: "#04cf66",
    fontSize: "16px",
  },
  trustBadge: {
    display: "flex",
    alignItems: "center",
  },
  trustIcon: {
    fontSize: "20px",
    color: "#04cf66",
    marginRight: theme.spacing(1),
  },
  trustHeading: {
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: 1.2,
    color: "#333",
  },
  trustSubheading: {
    fontSize: "12px",
    color: "#666",
    lineHeight: 1.2,
  },
  highlight: {
    color: "#04cf66",
    fontWeight: 700,
  },
  billingPeriodText: {
    fontSize: "12px",
    color: "#666",
    fontWeight: 500,
  },
  summaryItemDetails: {
    display: "flex",
    flexDirection: "column",
  },
  summaryItemPeriod: {
    fontSize: "12px",
    color: "#666",
    display: "block",
    marginTop: "2px",
  },
  discountChip: {
    backgroundColor: "#FFF4E5",
    color: "#FF9800",
    fontWeight: 700,
    fontSize: "11px",
    height: "22px",
    border: "1px solid #FFE0B2",
    "& .MuiChip-label": {
      padding: theme.spacing(0, 1),
      fontSize: "11px",
      fontWeight: 700,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
      height: "20px",
      "& .MuiChip-label": {
        fontSize: "10px",
        padding: theme.spacing(0, 0.75),
      },
    },
  },
  savingBadgeToggle: {
    fontSize: "10px",
    color: "#04cf66",
    backgroundColor: "rgba(4, 207, 102, 0.1)",
    padding: "1px 6px",
    borderRadius: "10px",
    fontWeight: 700,
    marginTop: "2px",
    display: "inline-block",
    [theme.breakpoints.down("sm")]: {
      fontSize: "9px",
      marginTop: "1px",
    },
  },
  originalPriceTotal: {
    textDecoration: "line-through",
    color: "#999",
    marginRight: theme.spacing(1),
    fontWeight: 500,
    fontSize: "15px",
    fontFamily: "'Inter', 'Helvetica', 'Arial', sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
}));

export default RegionalPlansPage;
